export enum DisplayType {
	Text = 0,
	TextArea = 1,
	Number = 2,
	Switch = 3,
	ColorPicker = 4,
	Dropdown = 5,
	Date = 6,
	DateField = 7
}
export enum FormType {
	AppointmentType = 0,
	ServiceCategory = 1,
	AccountRole = 2,
	StaffMember = 3,
	InventoryItem = 4,
	AddStock = 5,
	InventoryItemCategory = 6,
	LedgerEntry = 7,
	OneTimeExpense = 8,
	RecurringExpense = 9,
	MoneyAccount = 10,
	UpsertGiftCardTypeDTO = 11
}
export abstract class IMetadataController
{
	public abstract getFormsMetadata(): Promise<IFormsMetadataDTO>;
}
export interface IFieldMetadata
{
	isEditable: boolean;
	name: string;
	showWhen?: string;
	type: DisplayType;
	validationRules: any[];
}
export interface IAppointmentTypeDTO
{
	autoApply: boolean;
	categoryId: number;
	categoryName: string;
	children: IAppointmentTypeDTO[];
	color: string;
	commissionPercentage: number;
	description: string;
	disablePrice: boolean;
	discountPrice: number;
	durationInMinutes: number;
	eligibleForCommission: boolean;
	eligibleForCustomPrice: boolean;
	firstAvailable?: any;
	hideInBooking: boolean;
	id: number;
	image: string;
	isExtraService: boolean;
	mustPayOnline: boolean;
	order: number;
	payOnlinePrice: number;
	price: number;
	resources: IResourceDTO[];
	serviceDurationInMinutes: number;
	showCustomColor: boolean;
	title: string;
	unavailableForOnlineBooking: boolean;
}
export enum ValidationType {
	Required = 0,
	Min = 1,
	Max = 2,
	Number = 3,
	Email = 4,
	Phone = 5,
	Length = 6,
	Pattern = 7,
	Range = 8,
	Regex = 9
}
export enum HttpVerb {
	Get = 0,
	Post = 1,
	Put = 2,
	Delete = 3,
	Patch = 4,
	Head = 5,
	Options = 6,
	Trace = 7
}
export interface ICompanyDTO
{
	id: number;
}
export interface ICustomerStatDTO
{
	bookings: number;
	customerName: string;
	totalMoneySpent: number;
}
export interface INewCustomerStatsDTO
{
	monthlyNewCustomers: number[];
	monthlyTotalCustomers: number[];
}
export interface IServiceStatDTO
{
	bookings: number;
	color: string;
	serviceName: string;
}
export interface ITypeFormField
{
	description: string;
	name: string;
}
export interface AppointmentTypeFormDTO
{
	autoApply: ITypeFormField;
	color: ITypeFormField;
	commissionPercentage: ITypeFormField;
	description: ITypeFormField;
	disablePrice: ITypeFormField;
	durationInMinutes: ITypeFormField;
	eligibleForCommission: ITypeFormField;
	eligibleForCustomPrice: ITypeFormField;
	hideInBooking: ITypeFormField;
	isExtraService: ITypeFormField;
	mustPayOnline: ITypeFormField;
	payOnlinePrice: ITypeFormField;
	price: ITypeFormField;
	serviceDurationInMinutes: ITypeFormField;
	showCustomColor: ITypeFormField;
	title: ITypeFormField;
	unavailableForOnlineBooking: ITypeFormField;
}
export interface ServiceCategoryFormDTO
{
	title: ITypeFormField;
}
export interface AccountRoleFormDTO
{
	administration: ITypeFormField;
	appointmentsAndClients: ITypeFormField;
	name: ITypeFormField;
	settings: ITypeFormField;
	statisticsAndFinances: ITypeFormField;
}
export interface StaffMemberFormDTO
{
	commissionPercentageProducts: ITypeFormField;
	commissionPercentageServices: ITypeFormField;
	eligibleForCommission: ITypeFormField;
	eligibleForCommissionProducts: ITypeFormField;
	eligibleForCommissionServices: ITypeFormField;
	emailAddress: ITypeFormField;
	firstName: ITypeFormField;
	lastName: ITypeFormField;
	overrideProductsCommission: ITypeFormField;
	overrideServicesCommission: ITypeFormField;
	phoneNumber: ITypeFormField;
}
export interface InventoryItemFormDTO
{
	commissionPercentage: ITypeFormField;
	costPrice: ITypeFormField;
	currentStock: ITypeFormField;
	description: ITypeFormField;
	eligibleForCommission: ITypeFormField;
	isStockItem: ITypeFormField;
	minimumStockThreshold: ITypeFormField;
	name: ITypeFormField;
	reorderLevel: ITypeFormField;
	salePrice: ITypeFormField;
}
export interface AddStockFormDTO
{
	purchaseDate: ITypeFormField;
	quantity: ITypeFormField;
}
export interface InventoryItemCategoryFormDTO
{
	description: ITypeFormField;
	name: ITypeFormField;
}
export interface LedgerEntryFormDTO
{
	amount: ITypeFormField;
	description: ITypeFormField;
}
export interface OneTimeExpenseFormDTO
{
	amount: ITypeFormField;
	notes: ITypeFormField;
	purchaseDate: ITypeFormField;
}
export interface RecurringExpenseFormDTO
{
	amount: ITypeFormField;
	endDate: ITypeFormField;
	name: ITypeFormField;
	startDate: ITypeFormField;
}
export interface MoneyAccountFormDTO
{
	description: ITypeFormField;
	name: ITypeFormField;
}
export interface UpsertGiftCardTypeFormDTO
{
	durationDays: ITypeFormField;
	name: ITypeFormField;
	value: ITypeFormField;
}
export interface ITypeForms
{
	accountRoleDTO: AccountRoleFormDTO;
	addStockFormDTO: AddStockFormDTO;
	appointmentTypeFormDTO: AppointmentTypeFormDTO;
	inventoryItemCategoryFormDTO: InventoryItemCategoryFormDTO;
	inventoryItemFormDTO: InventoryItemFormDTO;
	ledgerEntryFormDTO: LedgerEntryFormDTO;
	moneyAccountFormDTO: MoneyAccountFormDTO;
	oneTimeExpenseFormDTO: OneTimeExpenseFormDTO;
	recurringExpenseFormDTO: RecurringExpenseFormDTO;
	serviceCategoryFormDTO: ServiceCategoryFormDTO;
	staffMemberFormDTO: StaffMemberFormDTO;
	upsertGiftCardTypeDTO: UpsertGiftCardTypeFormDTO;
}
export interface IPostInitialProfileDTO
{
	firstName: string;
	lastName: string;
	phoneNumber: string;
}
export interface IPostUserDTO
{
	abilityToCancel: boolean;
	activateEmailList: boolean;
	appointmentDistributionInMinutes: number;
	automaticAddCustomers: boolean;
	automaticCreateCustomers: boolean;
	bankAccount: string;
	bookingLink: string;
	bookingLocationName: string;
	cancellationBoxText: string;
	companyName: string;
	companyRole: number;
	connectedBookingLink: string;
	country: string;
	currency: string;
	customerCanSearchForAppointments: boolean;
	customerCanSelectStaff: boolean;
	customerMergeType: CustomerMergeType;
	customerReceiptAndReminderMode: string;
	customerRequiredAddress: boolean;
	customerRequiredBirthdate: boolean;
	customerRequiredCity: boolean;
	customerRequiredEmail: boolean;
	customerRequiredEmailOptional: boolean;
	customerRequiredGender: boolean;
	customerRequiredName: boolean;
	customerRequiredPhoneNumber: boolean;
	customerRequiredPhoneNumberOptional: boolean;
	customerRequiredPostalCode: boolean;
	customerRequiredSSN: boolean;
	dateOfBirth: any;
	defaultPhoneNumberCountryCode: number;
	dueDateLength: number;
	emailAddress: string;
	emailAddressToReceive: string;
	enablePaymentModule: boolean;
	firstName: string;
	gender: string;
	hideIrrelevantDaysInCalendar: boolean;
	hoursToCancel: number;
	informationBoxText: string;
	intervalMinutes: number;
	kidLength: number;
	kidMod: number;
	language: string;
	lastName: string;
	maxDaysInAdvanceForBooking: number;
	minumumHourBeforeBooking: number;
	multipleServices: boolean;
	onlineTransactionProvider: OnlineTransactionProvider;
	organizationNumber: string;
	phoneNumber: string;
	phoneNumberToReceive: string;
	recieveEmailOnAppointment: boolean;
	recieveSMSOnAppointment: boolean;
	recieveWhatsAppOnAppointment: boolean;
	sector: number;
	sendAutomaticallyReceipt: boolean;
	sendAutomaticallyReminder: boolean;
	showInformationBox: boolean;
	showOccupiedHoursForAnonymousBooking: boolean;
	showServiceNameInEvent: number;
	showServicePrice: boolean;
	showStaffMemberInEvent: number;
	showTimeInEvent: number;
	signUpDate: any;
	ssn: number;
	subscriptionType: number;
	taxPercentage: number;
	timeFormat: string;
	timeZone: string;
	treatmentAdress: string;
	useCustomerAccounts: boolean;
	useGiftCards: boolean;
	useKID: boolean;
	verificationType: VerificationType;
	whatsAppNumberToReceive: string;
}
export interface IPostFreshUserDTO
{
	bookingLink: string;
	companyName: string;
	currency: string;
	defaultPhoneNumberCountryCode: number;
	emailAddress: string;
	language: string;
	timeFormat: string;
	timeZone: string;
}
export interface IUserDTO
{
	abilityToCancel: boolean;
	activateEmailList: boolean;
	appointmentDistributionInMinutes: number;
	automaticAddCustomers: boolean;
	automaticCreateCustomers: boolean;
	bankAccount: string;
	bookingLink: string;
	bookingLocationName: string;
	cancellationBoxText: string;
	companyId: number;
	companyName: string;
	companyRole: number;
	connectedBookingLink: string;
	country: string;
	currency: string;
	customerCanSearchForAppointments: boolean;
	customerCanSelectStaff: boolean;
	customerMergeType: CustomerMergeType;
	customerReceiptAndReminderMode: string;
	customerRequiredAddress: boolean;
	customerRequiredBirthdate: boolean;
	customerRequiredCity: boolean;
	customerRequiredEmail: boolean;
	customerRequiredEmailOptional: boolean;
	customerRequiredGender: boolean;
	customerRequiredName: boolean;
	customerRequiredPhoneNumber: boolean;
	customerRequiredPhoneNumberOptional: boolean;
	customerRequiredPostalCode: boolean;
	customerRequiredSSN: boolean;
	dateOfBirth?: any;
	defaultPhoneNumberCountryCode: number;
	dueDateLength: number;
	emailAddress: string;
	emailAddressToReceive: string;
	emailVerified: boolean;
	enablePaymentModule: boolean;
	firstName: string;
	gender: string;
	hideIrrelevantDaysInCalendar: boolean;
	hoursToCancel: number;
	informationBoxText: string;
	intervalMinutes: number;
	kidLength: number;
	kidMod: number;
	language: string;
	lastName: string;
	lastYearlySubscription?: any;
	maxDaysInAdvanceForBooking: number;
	minumumHourBeforeBooking: number;
	multipleServices: boolean;
	onlineTransactionProvider: OnlineTransactionProvider;
	organizationNumber: string;
	phoneNumber: string;
	phoneNumberToReceive: string;
	profilePictureUrl: string;
	recieveEmailOnAppointment: boolean;
	recieveSMSOnAppointment: boolean;
	recieveWhatsAppOnAppointment: boolean;
	sector: number;
	sendAutomaticallyReceipt: boolean;
	sendAutomaticallyReminder: boolean;
	showInformationBox: boolean;
	showOccupiedHoursForAnonymousBooking: boolean;
	showServiceNameInEvent: number;
	showServicePrice: boolean;
	showStaffMemberInEvent: number;
	showTimeInEvent: number;
	signUpDate?: any;
	smsCredits: number;
	smsVerification: boolean;
	ssn: number;
	staffMemberId: number;
	subscriptionType: number;
	taxPercentage: number;
	timeFormat: string;
	timeZone: string;
	treatmentAdress: string;
	useCustomerAccounts: boolean;
	useGiftCards: boolean;
	useKID: boolean;
	userId: string;
	verificationType: VerificationType;
	whatsAppNumberToReceive: string;
}
export interface IRouteDefinition
{
	method: HttpVerb;
	queryType: string;
	url: string;
}
export class FormMetadata
{
	static accountrole: IFieldMetadata[] = [{
                    name: 'Name',
                    type: DisplayType.Text,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Required }]
                },
{
                    name: 'AppointmentsAndClients',
                    type: DisplayType.Dropdown,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Required }]
                },
{
                    name: 'Settings',
                    type: DisplayType.Dropdown,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Required }]
                },
{
                    name: 'StatisticsAndFinances',
                    type: DisplayType.Dropdown,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Required }]
                },
{
                    name: 'Administration',
                    type: DisplayType.Dropdown,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Required }]
                }];
	static addstock: IFieldMetadata[] = [{
                    name: 'Quantity',
                    type: DisplayType.Number,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Required }, { type: ValidationType.Min, value: 1 }, { type: ValidationType.Max, value: 2147483647 }]
                },
{
                    name: 'PurchaseDate',
                    type: DisplayType.Date,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Required }]
                }];
	static appointmenttype: IFieldMetadata[] = [{
                    name: 'Title',
                    type: DisplayType.Text,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Required }]
                },
{
                    name: 'Description',
                    type: DisplayType.TextArea,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                },
{
                    name: 'Price',
                    type: DisplayType.Number,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Min, value: 0 }, { type: ValidationType.Max, value: 2147483647 }]
                },
{
                    name: 'DurationInMinutes',
                    type: DisplayType.Number,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Required }, { type: ValidationType.Min, value: 1 }, { type: ValidationType.Max, value: 720 }]
                },
{
                    name: 'ServiceDurationInMinutes',
                    type: DisplayType.Number,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Min, value: 1 }, { type: ValidationType.Max, value: 720 }]
                },
{
                    name: 'HideInBooking',
                    type: DisplayType.Switch,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                },
{
                    name: 'AutoApply',
                    type: DisplayType.Switch,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                },
{
                    name: 'IsExtraService',
                    type: DisplayType.Switch,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                },
{
                    name: 'ShowCustomColor',
                    type: DisplayType.Switch,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                },
{
                    name: 'EligibleForCustomPrice',
                    type: DisplayType.Switch,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                },
{
                    name: 'Color',
                    type: DisplayType.ColorPicker,
                    isEditable: true,
                    showWhen: 'ShowCustomColor',
                    validationRules: []
                },
{
                    name: 'DisablePrice',
                    type: DisplayType.Switch,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                },
{
                    name: 'MustPayOnline',
                    type: DisplayType.Switch,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                },
{
                    name: 'EligibleForCommission',
                    type: DisplayType.Switch,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                },
{
                    name: 'CommissionPercentage',
                    type: DisplayType.Number,
                    isEditable: true,
                    showWhen: 'EligibleForCommission',
                    validationRules: [{ type: ValidationType.Min, value: 0 }, { type: ValidationType.Max, value: 100 }]
                },
{
                    name: 'PayOnlinePrice',
                    type: DisplayType.Number,
                    isEditable: true,
                    showWhen: 'MustPayOnline',
                    validationRules: [{ type: ValidationType.Min, value: 0 }, { type: ValidationType.Max, value: 2147483647 }]
                }];
	static inventoryitem: IFieldMetadata[] = [{
                    name: 'Name',
                    type: DisplayType.Text,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Required }]
                },
{
                    name: 'Description',
                    type: DisplayType.TextArea,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                },
{
                    name: 'SalePrice',
                    type: DisplayType.Number,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Required }]
                },
{
                    name: 'IsStockItem',
                    type: DisplayType.Switch,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                },
{
                    name: 'CostPrice',
                    type: DisplayType.Number,
                    isEditable: true,
                    showWhen: 'IsStockItem',
                    validationRules: [{ type: ValidationType.Required }]
                },
{
                    name: 'CurrentStock',
                    type: DisplayType.Number,
                    isEditable: true,
                    showWhen: 'IsStockItem',
                    validationRules: [{ type: ValidationType.Required }]
                },
{
                    name: 'MinimumStockThreshold',
                    type: DisplayType.Number,
                    isEditable: true,
                    showWhen: 'IsStockItem',
                    validationRules: [{ type: ValidationType.Required }]
                },
{
                    name: 'ReorderLevel',
                    type: DisplayType.Number,
                    isEditable: true,
                    showWhen: 'IsStockItem',
                    validationRules: []
                },
{
                    name: 'EligibleForCommission',
                    type: DisplayType.Switch,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                },
{
                    name: 'CommissionPercentage',
                    type: DisplayType.Number,
                    isEditable: true,
                    showWhen: 'EligibleForCommission',
                    validationRules: [{ type: ValidationType.Min, value: 0 }, { type: ValidationType.Max, value: 100 }]
                }];
	static inventoryitemcategory: IFieldMetadata[] = [{
                    name: 'Name',
                    type: DisplayType.Text,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Required }]
                },
{
                    name: 'Description',
                    type: DisplayType.TextArea,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                }];
	static ledgerentry: IFieldMetadata[] = [{
                    name: 'Amount',
                    type: DisplayType.Number,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Required }]
                },
{
                    name: 'Description',
                    type: DisplayType.Text,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                }];
	static moneyaccount: IFieldMetadata[] = [{
                    name: 'Name',
                    type: DisplayType.Text,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Required }]
                },
{
                    name: 'Description',
                    type: DisplayType.Text,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                }];
	static onetimeexpense: IFieldMetadata[] = [{
                    name: 'PurchaseDate',
                    type: DisplayType.DateField,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Required }]
                },
{
                    name: 'Notes',
                    type: DisplayType.TextArea,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                },
{
                    name: 'Amount',
                    type: DisplayType.Number,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Required }]
                }];
	static recurringexpense: IFieldMetadata[] = [{
                    name: 'StartDate',
                    type: DisplayType.DateField,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                },
{
                    name: 'EndDate',
                    type: DisplayType.DateField,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                },
{
                    name: 'Name',
                    type: DisplayType.Text,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                },
{
                    name: 'Amount',
                    type: DisplayType.Number,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                }];
	static servicecategory: IFieldMetadata[] = [{
                    name: 'Title',
                    type: DisplayType.Text,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Required }]
                }];
	static staffmember: IFieldMetadata[] = [{
                    name: 'FirstName',
                    type: DisplayType.Text,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Required }]
                },
{
                    name: 'LastName',
                    type: DisplayType.Text,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Required }]
                },
{
                    name: 'PhoneNumber',
                    type: DisplayType.Text,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Phone }, { type: ValidationType.Required }]
                },
{
                    name: 'EmailAddress',
                    type: DisplayType.Text,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                },
{
                    name: 'EligibleForCommission',
                    type: DisplayType.Switch,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                },
{
                    name: 'EligibleForCommissionServices',
                    type: DisplayType.Switch,
                    isEditable: true,
                    showWhen: 'EligibleForCommission',
                    validationRules: []
                },
{
                    name: 'EligibleForCommissionProducts',
                    type: DisplayType.Switch,
                    isEditable: true,
                    showWhen: 'EligibleForCommission',
                    validationRules: []
                },
{
                    name: 'OverrideServicesCommission',
                    type: DisplayType.Switch,
                    isEditable: true,
                    showWhen: 'EligibleForCommission',
                    validationRules: []
                },
{
                    name: 'OverrideProductsCommission',
                    type: DisplayType.Switch,
                    isEditable: true,
                    showWhen: 'EligibleForCommission',
                    validationRules: []
                },
{
                    name: 'CommissionPercentageServices',
                    type: DisplayType.Number,
                    isEditable: true,
                    showWhen: 'OverrideServicesCommission',
                    validationRules: [{ type: ValidationType.Min, value: 0 }, { type: ValidationType.Max, value: 100 }]
                },
{
                    name: 'CommissionPercentageProducts',
                    type: DisplayType.Number,
                    isEditable: true,
                    showWhen: 'OverrideProductsCommission',
                    validationRules: [{ type: ValidationType.Min, value: 0 }, { type: ValidationType.Max, value: 100 }]
                }];
	static upsertgiftcardtypedto: IFieldMetadata[] = [{
                    name: 'Name',
                    type: DisplayType.Text,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Required }]
                },
{
                    name: 'Value',
                    type: DisplayType.Number,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: [{ type: ValidationType.Required }]
                },
{
                    name: 'DurationDays',
                    type: DisplayType.Number,
                    isEditable: true,
                    showWhen: undefined,
                    validationRules: []
                }];
}
export interface IEditCustomerAccountDTO
{
	address: string;
	city: string;
	country: string;
	dateOfBirth: any;
	emailAddress: string;
	firstName: string;
	gender: string;
	password: string;
	phoneNumber: string;
	phoneNumberCountryCode: number;
	postalCode: string;
	ssn: string;
	userId: string;
}
export interface IPostCustomerAccountDTO
{
	address: string;
	adminId: string;
	city: string;
	dateOfBirth?: any;
	emailAddress: string;
	firstName: string;
	gender: string;
	lastName: string;
	password: string;
	phoneNumber: string;
	postalCode: string;
	ssn: string;
}
export interface ICustomerAccountAnonymousRequest
{
	adminId: string;
	login: string;
}
export interface ICustomerAccountRequest
{
	adminId: string;
	login: string;
	password: string;
}
export interface IResetPasswordByCode
{
	adminId: string;
	code: string;
	login: string;
	newPassword: string;
}
export interface IAppointmentChangeAsCustomAccount
{
	adminId: string;
	appointmentId: number;
	customerToken: string;
	day: number;
	hour: number;
	minute: number;
	month: number;
	phoneNumber: string;
	serviceIds: number[];
	year: number;
}
export interface IAppointmentAnonymousPostDTO
{
	address: string;
	appointmentTypeId: number;
	cancelUrl: string;
	comment: string;
	customerAccountIdentificationCode: string;
	day: number;
	emailAddress: string;
	emailReceipt: boolean;
	emailReminder: boolean;
	firstName: string;
	hour: number;
	lastName: string;
	minute: number;
	month: number;
	password: string;
	phoneNumber: string;
	postalCode: string;
	smsReceipt: boolean;
	smsReminder: boolean;
	userId: string;
	whatsappReceipt: boolean;
	whatsappReminder: boolean;
	year: number;
}
export interface ICustomerAccountDTO
{
	address: string;
	adminId: string;
	adminUserId: string;
	city: string;
	country: string;
	dateAdded?: any;
	dateOfBirth?: any;
	emailAddress: string;
	firstName: string;
	gender: string;
	id: number;
	lastName: string;
	password: string;
	phoneNumber: string;
	phoneNumberCountryCode: number;
	postalCode: string;
	ssn: string;
	verified: boolean;
}
export interface IStaffMemberCalendarIntervalsDTO
{
	intervals: ICalendarInterval[];
	staffMemberId: number;
}
export abstract class IUserController
{
	static GetBookingIntervalSettingsRoute: IRouteDefinition = { url: "User/current/bookingSettings/intervals", method: HttpVerb.Get, queryType: "" };
	static GetBookingSettingsRoute: IRouteDefinition = { url: "User/current/bookingSettings", method: HttpVerb.Get, queryType: "" };
	static GetCurrentUserRoute: IRouteDefinition = { url: "User/current", method: HttpVerb.Get, queryType: "" };
	static PatchUserRoute: IRouteDefinition = { url: "User/current", method: HttpVerb.Patch, queryType: "" };
	static PostPictureRoute: IRouteDefinition = { url: "User/current/Picture", method: HttpVerb.Put, queryType: "" };
	static PostUserRoute: IRouteDefinition = { url: "User/current", method: HttpVerb.Post, queryType: "" };
	static PutBookingSettingsRoute: IRouteDefinition = { url: "User/current/bookingSettings", method: HttpVerb.Put, queryType: "" };
	static PutUserProfileOnlyRoute: IRouteDefinition = { url: "User/current/profile", method: HttpVerb.Put, queryType: "" };
	static PutUserRoute: IRouteDefinition = { url: "User/current", method: HttpVerb.Put, queryType: "" };
	public abstract getCurrentUser(): Promise<IUserDTO>;
	public abstract getUser(userId: string): Promise<IUserDTO>;
	public abstract getUserByUsername(companyName: string): Promise<IUserDTO>;
	public abstract putUserProfileOnly(userDto: IPostInitialProfileDTO): Promise<any>;
	public abstract patchUser(patchDoc: any): Promise<any>;
	public abstract putUser(userDto: IPostUserDTO): Promise<any>;
	public abstract postUser(userDTO: IPostFreshUserDTO): Promise<any>;
	public abstract deleteCompanyEmployee(id: string): Promise<any>;
	public abstract getBookingIntervalSettings(staffMemberId?: number): Promise<IStaffMemberCalendarIntervalsDTO[]>;
	public abstract getBookingSettings(staffMemberId?: number): Promise<IUserBookingSettingsAsHoursAndMinutesDTO>;
	public abstract putBookingSettings(bookingSettingsDto: IUserBookingSettingsAsHoursAndMinutesDTO, staffMemberId?: number): Promise<any>;
	public abstract postPicture(file: any[]): Promise<any>;
}
export interface IAppointmentCustomFieldDTO
{
	appointmentId: number;
	bookingId: number;
	customFieldId: number;
	id: number;
	userId: string;
	value: string;
}
export interface IPostAppointmentCustomFieldDTO
{
	customFieldId: number;
	id: number;
	userId: string;
	value: string;
}
export interface IAuditLogDTO
{
	action: number;
	comment: string;
	firebaseUserId: string;
	firebaseUserName: string;
	hideForUser: boolean;
	id: number;
	message: string;
	time: any;
	type: number;
}
export interface IPostAuditLogDTO
{
	action: number;
	comment: string;
	hideForUser: boolean;
	message: string;
	type: number;
}
export interface ICustomFieldDTO
{
	archived: boolean;
	created: any;
	enabled: boolean;
	id: number;
	label: string;
	optional: boolean;
	userId: string;
}
export interface IInsuranceDTO
{
	address: string;
	bankAccount: string;
	city: string;
	country: string;
	emailAddress: string;
	id: number;
	name: string;
	phoneNumber: string;
	postalCode: string;
	userId: string;
}
export interface ISendInvoiceDTO
{
	cc: string;
	emailAddress: string;
	id: number;
	markAsPaid: boolean;
}
export interface IPostInvoiceDTO
{
	appointmentId: number;
	appointmentNumber: number;
	appointmentServicePrice: number;
	bankAccount: string;
	chargeAmount: number;
	companyEmail: string;
	companyName: string;
	companyPhone: string;
	customerAccountId: number;
	customerAddress: string;
	customerCity: string;
	customerCountry: string;
	customerEmailAddress: string;
	customerId: number;
	customerName: string;
	customerPhoneNumber: string;
	customerPostalCode: string;
	dischargeAmount: number;
	dueDays: number;
	id: number;
	invoiceNumber: number;
	kid: string;
	markAsPaid: boolean;
	organizationNumber: string;
	senderName: string;
	service: string;
	serviceQuantity: number;
	status: string;
	vat: number;
}
export interface IInvoiceDTO
{
	appointmentId: number;
	appointmentNumber: number;
	appointmentServicePrice: number;
	bankAccount: string;
	chargeAmount: number;
	companyEmail: string;
	companyName: string;
	companyPhone: string;
	customerAccountId: number;
	customerAddress: string;
	customerCity: string;
	customerCountry: string;
	customerEmailAddress: string;
	customerId: number;
	customerName: string;
	customerPhoneNumber: string;
	customerPostalCode: string;
	date: any;
	dischargeAmount: number;
	dueDate: any;
	dueDays: number;
	id: number;
	invoiceNumber: number;
	kid: string;
	organizationNumber: string;
	senderName: string;
	service: string;
	serviceQuantity: number;
	status: string;
	vat: number;
}
export interface INotificationDTO
{
	adminId: string;
	content: string;
	createdTime?: any;
	customerId: number;
	hasSeen: boolean;
	id: number;
	seenTime?: any;
	title: string;
}
export interface IResourceDTO
{
	amount: number;
	created: any;
	description: string;
	id: number;
	name: string;
	services: IAppointmentTypeDTO[];
	userId: string;
}
export interface IPostResourceDTO
{
	amount: number;
	description: string;
	name: string;
}
export interface IServiceCategoryDTO
{
	archived: boolean;
	id: number;
	order: number;
	title: string;
}
export interface IPostServiceCategoryDTO
{
	id: number;
	order: number;
	title: string;
}
export interface IStaffMemberDTO
{
	color: string;
	commissionPercentageProducts: number;
	commissionPercentageServices: number;
	companyRole: number;
	dateOfBirth?: any;
	eligibleForCommission: boolean;
	eligibleForCommissionProducts: boolean;
	eligibleForCommissionServices: boolean;
	emailAddress: string;
	firstName: string;
	fridayCloseFromMidnight: number;
	fridayOpenFromMidnight: number;
	fullName: string;
	gender: string;
	id: number;
	imageUrl: string;
	lastName: string;
	mondayCloseFromMidnight: number;
	mondayOpenFromMidnight: number;
	notificationType: NotificationType;
	overrideProductsCommission: boolean;
	overrideServicesCommission: boolean;
	phoneNumber: string;
	profilePictureUrl: string;
	role: string;
	saturdayCloseFromMidnight: number;
	saturdayOpenFromMidnight: number;
	sector: number;
	services: IAppointmentTypeDTO[];
	sundayCloseFromMidnight: number;
	sundayOpenFromMidnight: number;
	thursdayCloseFromMidnight: number;
	thursdayOpenFromMidnight: number;
	tuesdayCloseFromMidnight: number;
	tuesdayOpenFromMidnight: number;
	vacationDays: IVacationDayDTO[];
	wednesdayCloseFromMidnight: number;
	wednesdayOpenFromMidnight: number;
	workingDays: any[];
}
export interface IStaffMemberBookingDTO extends IStaffMemberDTO
{
	nextAvailable?: any;
}
export interface IUpdateLogDTO
{
	hasRead: boolean;
	html: string;
	time: any;
	title: string;
}
export interface IVacationDayDTO
{
	adminId: string;
	day: number;
	month: number;
	year: number;
}
export enum NotificationType {
	None = 0,
	Email = 1,
	Whatsapp = 2,
	Sms = 3
}
export enum ShowStaffMemberInEvent {
	None = 0,
	Label = 1,
	Color = 2
}
export enum VerificationType {
	None = 0,
	Email = 1,
	Phone = 2
}
export enum CustomerMergeType {
	None = 0,
	Phone = 1
}
export interface IAppointmentInfoDTO
{
	adminEmail: string;
	adminNote: string;
	appointmentDuration: string;
	appointmentName: string;
	appointmentTypePrice: number;
	archived: boolean;
	canCancel: boolean;
	comment: string;
	companyAddress: string;
	companyName: string;
	created: any;
	createdByCustomer: boolean;
	customerAddress: string;
	customerCity: string;
	customerEmail: string;
	customerId: number;
	customerInsuranceId?: number;
	customerName: string;
	customerPhone: string;
	customerPhoneCountryCode: number;
	customerPostalCode: string;
	date?: any;
	day: number;
	description: string;
	duration: number;
	giftCardRedemptions: IAppointmentGiftCardRedemptionDTO[];
	hasBeen: boolean;
	hasGiftCardRedemptions: boolean;
	hour: number;
	id: number;
	isCustom: boolean;
	minute: number;
	month: number;
	number: number;
	paid: boolean;
	price: number;
	serviceIds: number[];
	staffMemberId: number;
	staffMemberName: string;
	status: string;
	useLedgerEntry: boolean;
	year: number;
	dateIsWithinOneDay() : boolean;
	getDate() : any;
	getDateEnd() : any;
}
export interface IAppointmentGiftCardRedemptionDTO
{
	amount: number;
	balanceAfter: number;
	currency: string;
	giftCardCode: string;
	giftCardId: number;
	initialValue: number;
	notes: string;
	redeemedAt: any;
}
export interface IEditAppointmentDTO
{
	adminNote: string;
	bookedDateTime?: any;
	comment: string;
	customerId: number;
	customerName: string;
	day: number;
	duration: number;
	hour: number;
	id: number;
	minute: number;
	month: number;
	number: number;
	paid?: boolean;
	price: number;
	serviceIds: number[];
	staffMemberId: number;
	status: string;
	year: number;
}
export interface IAppointmentDTO
{
	adminNote: string;
	appointmentTypeId: number;
	bookedDateTime?: any;
	comment: string;
	customerId: number;
	customerName: string;
	day: number;
	description: string;
	duration: number;
	hour: number;
	id: number;
	isCustom: boolean;
	minute: number;
	month: number;
	number: number;
	paid: boolean;
	price: number;
	status: string;
	year: number;
}
export interface IPostAppointmentDTO
{
	bookedDateTime?: any;
	comment: string;
	customerId: number;
	customerName: string;
	day: number;
	description: string;
	duration: number;
	emailReminder: boolean;
	forceCreate?: boolean;
	giftCardRedemptions: IPostGiftCardRedemptionDTO[];
	hour: number;
	id: number;
	minute: number;
	moneyAccountId?: number;
	month: number;
	number: number;
	paid: boolean;
	partialPaymentAmount?: number;
	paymentStatus: string;
	price: number;
	serviceIds: number[];
	smsReminder: boolean;
	staffMemberId: number;
	status: string;
	whatsappReminder: boolean;
	year: number;
}
export interface IUserBookingSettingsDTO
{
	fridayCloseFromMidnight: number;
	fridayOpenFromMidnight: number;
	mondayCloseFromMidnight: number;
	mondayOpenFromMidnight: number;
	saturdayCloseFromMidnight: number;
	saturdayOpenFromMidnight: number;
	sundayCloseFromMidnight: number;
	sundayOpenFromMidnight: number;
	thursdayCloseFromMidnight: number;
	thursdayOpenFromMidnight: number;
	tuesdayCloseFromMidnight: number;
	tuesdayOpenFromMidnight: number;
	wednesdayCloseFromMidnight: number;
	wednesdayOpenFromMidnight: number;
}
export interface IUserBookingSettingsAsHoursAndMinutesDTO
{
	fridayCloseFromMidnight: string;
	fridayOpenFromMidnight: string;
	mondayCloseFromMidnight: string;
	mondayOpenFromMidnight: string;
	saturdayCloseFromMidnight: string;
	saturdayOpenFromMidnight: string;
	sundayCloseFromMidnight: string;
	sundayOpenFromMidnight: string;
	thursdayCloseFromMidnight: string;
	thursdayOpenFromMidnight: string;
	tuesdayCloseFromMidnight: string;
	tuesdayOpenFromMidnight: string;
	wednesdayCloseFromMidnight: string;
	wednesdayOpenFromMidnight: string;
}
export interface IBookingDTO
{
	address: string;
	canCancel: boolean;
	cancelExpiration: any;
	cancelId: string;
	cancelUrl: string;
	city: string;
	comment: string;
	created: any;
	customerAccountIdentificationCode: string;
	day: number;
	emailAddress: string;
	emailReceipt: boolean;
	emailReminder: boolean;
	firstName: string;
	hour: number;
	id: number;
	lastName: string;
	minute: number;
	month: number;
	password: string;
	phoneNumber: string;
	phoneNumberCountryCode: number;
	postalCode: string;
	sendReminder: boolean;
	serviceId: number;
	smsReceipt: boolean;
	smsReminder: boolean;
	staffMemberId: number;
	userId: string;
	verificationCode: string;
	verified: boolean;
	whatsappReceipt: boolean;
	whatsappReminder: boolean;
	year: number;
}
export interface IPostBookingDTO
{
	address: string;
	cancelUrl: string;
	city: string;
	comment: string;
	customerAccountIdentificationCode: string;
	customFields: IPostAppointmentCustomFieldDTO[];
	day: number;
	emailAddress: string;
	emailReceipt: boolean;
	emailReminder: boolean;
	firstName: string;
	giftCardRedemptions: IPostGiftCardRedemptionDTO[];
	hour: number;
	lastName: string;
	minute: number;
	month: number;
	password: string;
	phoneNumber: string;
	phoneNumberCountryCode: number;
	postalCode: string;
	serviceBookings: IServiceBookingPostDTO[];
	signupNewsletter: boolean;
	smsReceipt: boolean;
	smsReminder: boolean;
	staffMemberId: number;
	userId: string;
	whatsappReceipt: boolean;
	whatsappReminder: boolean;
	year: number;
}
export interface IBookingPageDTO
{
	id: string;
	name: string;
}
export interface ICustomerJournalDTO
{
	adminId: string;
	companyId: number;
	content: string;
	customerId: number;
	entryDate: any;
	id: number;
	title: string;
}
export interface IDebugLogDTO
{
	eventId: number;
	hasSeen: boolean;
	id: number;
	innerMessage: string;
	message: string;
	stackTrace: string;
	time: any;
}
export interface IEventDTO
{
	appointmentTime: any;
	comment: string;
	customerName: string;
	eventId: number;
	hasSeen: boolean;
	id: number;
	message: string;
	messageData: number;
	receipt: boolean;
	reminder: boolean;
	services: string;
	time: any;
}
export interface ICustomerStatisticsDTO
{
	balanceOverall: number;
	balanceThisMonth: number;
	ordersOverall: number;
	ordersThisMonth: number;
}
export interface ICustomerDTO
{
	address: string;
	balance: number;
	city: string;
	country: string;
	createdByCustomer: boolean;
	dateAdded?: any;
	dateOfBirth?: any;
	emailAddress: string;
	firstName: string;
	gender: string;
	generalInfo: string;
	id: number;
	insuranceId: number;
	insuranceName: string;
	lastName: string;
	phoneNumber: string;
	phoneNumberCountryCode: string;
	postalCode: string;
	sendEmailReminder: boolean;
	sendSmsReminder: boolean;
	ssn: string;
}
export interface IPaginatedAppointmentResponseDTO
{
	items: IAppointmentInfoDTO[];
	itemsPerPage: number;
	page: number;
	sortBy: string;
	sortDesc: boolean;
	total: number;
}
export abstract class IAppointmentScreenController
{
	static ArchiveRoute: IRouteDefinition = { url: "Appointment/current/archive", method: HttpVerb.Post, queryType: "" };
	static ChangeStatusRoute: IRouteDefinition = { url: "Appointment/current/{id}/status", method: HttpVerb.Patch, queryType: "" };
	static FindInCalendarRoute: IRouteDefinition = { url: "Appointment/current/{id}/find-in-calendar", method: HttpVerb.Post, queryType: "" };
	static GetListScreenRoute: IRouteDefinition = { url: "Appointment/current/list/screen", method: HttpVerb.Get, queryType: "IGetListScreenQuery" };
	static GetPageScreenRoute: IRouteDefinition = { url: "Appointment/current/number/{number}/screen", method: HttpVerb.Get, queryType: "IGetPageScreenQuery" };
	static RedeemGiftCardRoute: IRouteDefinition = { url: "Appointment/current/{id}/gift-cards/redeem", method: HttpVerb.Post, queryType: "" };
	static SaveAdminNoteRoute: IRouteDefinition = { url: "Appointment/current/{id}/admin-note", method: HttpVerb.Patch, queryType: "" };
	static SearchGiftCardsRoute: IRouteDefinition = { url: "Appointment/current/{id}/gift-cards", method: HttpVerb.Get, queryType: "" };
	private static tryDay(text: string, day: any) : boolean
	{
		return null;
	}
	private write<T>(action: (arg: any, arg1: any) => Promise<any>) : any
	{
		return null;
	}
	public abstract getListScreen(query: Partial<typeof IAppointmentScreenController.IGetListScreenQuery>): Promise<IAppointmentListScreenDTO>;
	public abstract getPageScreen(query: Partial<typeof IAppointmentScreenController.IGetPageScreenQuery>): Promise<IAppointmentPageScreenDTO>;
	public abstract findInCalendar(id: number): Promise<any>;
	public abstract changeStatus(id: number, body: IAppointmentStatusChangeDTO): Promise<IAppointmentStatusDTO>;
	public abstract saveAdminNote(id: number, body: IAppointmentAdminNoteDTO): Promise<IAppointmentAdminNoteDTO>;
	public abstract archive(body: IAppointmentArchiveRequestDTO): Promise<IAppointmentArchiveResultDTO>;
	public abstract searchGiftCards(id: number, search?: string): Promise<IAppointmentGiftCardSearchDTO>;
	public abstract redeemGiftCard(id: number, body: IAppointmentGiftCardRedeemDTO): Promise<IAppointmentPageScreenDTO>;
	    public static IGetListScreenQuery: {
	        page: number | null;
	        pageSize: number | null;
	        sort: string | null;
	        desc: string | null;
	        status: string[] | null;
	        search: string | null;
	        staffMemberId: number | null;
	        customerId: number | null;
	        from: string | null;
	        to: string | null;
	    };
	    public static IGetPageScreenQuery: {
	        visit: string | null;
	    };
}
export interface IAppointmentForWeeklyCalenderDTO
{
	adminNote: string;
	appointmentId: number;
	appointmentName: string;
	appointmentNumber: number;
	appointmentPrice: number;
	appointmentTypeIds: number[];
	booked: any;
	category: string;
	color: string;
	comment: string;
	createdByCustomer: boolean;
	customerEmail: string;
	customerId: number;
	customerPhone: string;
	customFields: [string,string][];
	day: number;
	duration: number;
	end: any;
	hasGiftCardRedemption: boolean;
	hour: number;
	isCustom: boolean;
	isRegularCustomer: boolean;
	minute: number;
	month: number;
	name: string;
	staffMemberId: number;
	staffMemberName: string;
	staffMembersProvidingService: number[];
	start: any;
	status: string;
	year: number;
}
export abstract class IAppointmentController
{
	static ArchiveAppointmentRoute: IRouteDefinition = { url: "Appointment/current", method: HttpVerb.Delete, queryType: "" };
	static ChangeAsCustomerAccountRoute: IRouteDefinition = { url: "Appointment/ChangeAsCustomerAccount", method: HttpVerb.Put, queryType: "" };
	static ChangeStaffMemberRoute: IRouteDefinition = { url: "Appointment/current/staffMember", method: HttpVerb.Patch, queryType: "" };
	static CheckAppointmentOverlapRoute: IRouteDefinition = { url: "Appointment/current/check-overlap", method: HttpVerb.Post, queryType: "" };
	static DeleteAppointmentByCustomerAccountLoginRoute: IRouteDefinition = { url: "Appointment/cancelByCustomer", method: HttpVerb.Post, queryType: "" };
	static DownloadExcelRapportRoute: IRouteDefinition = { url: "Appointment/current/download", method: HttpVerb.Get, queryType: "" };
	static EditAppointmentRoute: IRouteDefinition = { url: "Appointment/current", method: HttpVerb.Put, queryType: "" };
	static GetAppointmentByNumberRoute: IRouteDefinition = { url: "Appointment/current/number/{appointmentNumber}", method: HttpVerb.Get, queryType: "" };
	static GetAppointmentRoute: IRouteDefinition = { url: "Appointment/{appointmentId}", method: HttpVerb.Get, queryType: "" };
	static GetAppointmentsForAdminCustomerRoute: IRouteDefinition = { url: "Appointment/current/customer/{customerId}", method: HttpVerb.Get, queryType: "" };
	static GetAppointmentsForAdminForEventCalenderRoute: IRouteDefinition = { url: "Appointment/onEvent/forCalender/current", method: HttpVerb.Get, queryType: "" };
	static GetAppointmentsForAdminRoute: IRouteDefinition = { url: "Appointment/current", method: HttpVerb.Get, queryType: "IGetAppointmentsForAdminQuery" };
	static GetAppointmentsForMonthAdminForCalenderRoute: IRouteDefinition = { url: "Appointment/OnMonth/forCalender/current", method: HttpVerb.Get, queryType: "" };
	static GetAppointmentsForWeekAdminForCalenderRoute: IRouteDefinition = { url: "Appointment/onWeek/forCalender/current", method: HttpVerb.Get, queryType: "" };
	static GetAvailableHoursCacheRoute: IRouteDefinition = { url: "Appointment/availableHours/cache", method: HttpVerb.Post, queryType: "" };
	static GetAvailableHoursForBookingPOSTRoute: IRouteDefinition = { url: "Appointment/availableHours", method: HttpVerb.Post, queryType: "" };
	static GetAvailableHoursForMonthRoute: IRouteDefinition = { url: "Appointment/availablehours/month", method: HttpVerb.Post, queryType: "" };
	static GetCustomerAccountAppointmentsRoute: IRouteDefinition = { url: "Appointment/forCustomerAccount", method: HttpVerb.Post, queryType: "" };
	static GetFirstAvailableDayForBookingRoute: IRouteDefinition = { url: "Appointment/firstAvailableHourDay", method: HttpVerb.Post, queryType: "" };
	static PatchAppointmentRoute: IRouteDefinition = { url: "Appointment/current", method: HttpVerb.Patch, queryType: "" };
	static PostAppointmentRoute: IRouteDefinition = { url: "Appointment/current", method: HttpVerb.Post, queryType: "" };
	static SendEmailRemindersRoute: IRouteDefinition = { url: "Appointment/sendEmailReminders", method: HttpVerb.Post, queryType: "" };
	static VerifyAppointmentRoute: IRouteDefinition = { url: "Appointment/verify", method: HttpVerb.Post, queryType: "" };
	public abstract getFirstAvailableDayForBooking(request: IAvailableHoursRequestDTO): Promise<any | null>;
	public abstract getAvailableHoursCache(request: IAvailableHoursRequestDTO): Promise<ILoadedHourToBookDTO[]>;
	public abstract getAvailableHoursForBookingPOST(request: IAvailableHoursRequestDTO): Promise<IHourToBookDTO[]>;
	public abstract getAppointmentsForAdmin(query: Partial<typeof IAppointmentController.IGetAppointmentsForAdminQuery>): Promise<IPaginatedAppointmentResponseDTO>;
	public abstract downloadExcelRapport(): Promise<Blob>;
	public abstract getAppointmentByNumber(appointmentNumber: number): Promise<IAppointmentInfoDTO>;
	public abstract getAppointmentsForAdminCustomer(customerId: number): Promise<IAppointmentInfoDTO[]>;
	public abstract changeAsCustomerAccount(customerAccount: IAppointmentChangeAsCustomAccount): Promise<void>;
	public abstract getCustomerAccountAppointments(customerAccount: ICustomerAccountDTO): Promise<IAppointmentInfoDTO[]>;
	public abstract getAppointmentsForAdminForEventCalender(day: number, month: number, year: number): Promise<IAppointmentForWeeklyCalenderDTO[]>;
	public abstract getAppointmentsForMonthAdminForCalender(month: number, year: number): Promise<IAppointmentForWeeklyCalenderDTO[]>;
	public abstract getAppointmentsForWeekAdminForCalender(week: number, year: number, extraWeek: boolean): Promise<IAppointmentForWeeklyCalenderDTO[]>;
	public abstract getAvailableHoursForMonth(request: IAvailableHoursRequestDTO): Promise<ILoadedHourToBookDTO[]>;
	public abstract getAppointment(appointmentId: number): Promise<IAppointmentDTO>;
	public abstract editAppointment(appointment: IEditAppointmentDTO): Promise<any>;
	public abstract changeStaffMember(staffMemberId: number, appointmentId: number): Promise<any>;
	public abstract patchAppointment(patchDoc: any, appointmentId: number): Promise<any>;
	public abstract postNewBooking(bookingPost: IPostBookingDTO, userId: string): Promise<any>;
	public abstract postAppointment(appointment: IPostAppointmentDTO): Promise<any>;
	public abstract checkAppointmentOverlap(appointment: IPostAppointmentDTO): Promise<boolean>;
	public abstract archiveAppointment(id: number): Promise<any>;
	public abstract verifyAppointment(verificationCode: string, userId: string): Promise<void>;
	public abstract deleteAppointmentByCustomerAccountLogin(appointmentId: number, customerToken: string, phoneNumber: string, userId: string): Promise<any>;
	    public static IGetAppointmentsForAdminQuery: {
	        page: number | null;
	        itemsPerPage: number | null;
	        sortBy: string | null;
	        desc: string | null;
	        staffMemberId: number | null;
	        customerId: number | null;
	    };
}
export abstract class ICustomerJournalsController
{
	static GetCustomerJournalByCustomerIdRoute: IRouteDefinition = { url: "CustomerJournal/current/customerId", method: HttpVerb.Get, queryType: "" };
	static GetCustomerJournalRoute: IRouteDefinition = { url: "CustomerJournal/current/{customerJournalId}", method: HttpVerb.Get, queryType: "" };
	static PostCustomerJournalRoute: IRouteDefinition = { url: "CustomerJournal/current", method: HttpVerb.Post, queryType: "" };
	static PutCustomerJournalRoute: IRouteDefinition = { url: "CustomerJournal/current", method: HttpVerb.Put, queryType: "" };
	public abstract getCustomerJournal(customerJournalId: number): Promise<ICustomerJournalDTO>;
	public abstract getCustomerJournalByCustomerId(customerId: number): Promise<ICustomerJournalDTO[]>;
	public abstract putCustomerJournal(newJournalInfo: any): Promise<void>;
	public abstract postCustomerJournal(customerJournal: any): Promise<void>;
}
export interface ICustomerTokenDataDTO
{
	appointments: IAppointmentInfoDTO[];
	customer: ICustomerDTO;
}
export interface ICustomerDetailedStatisticsDTO
{
	appointmentsThisMonth: number;
	appointmentsTotal: number;
	moneySpentThisMonth: number;
	moneySpentTotal: number;
	monthlySpending: IMonthlySpendingDTO[];
	productsSoldThisMonth: number;
	productsSoldTotal: number;
	ranking: ICustomerRankingDTO;
	servicesMoneyThisMonth: number;
	servicesMoneyTotal: number;
	topProducts: IProductUsageDTO[];
	topServices: IServiceUsageDTO[];
}
export interface IServiceUsageDTO
{
	serviceName: string;
	totalSpent: number;
	usageCount: number;
}
export interface IProductUsageDTO
{
	productName: string;
	quantity: number;
	totalSpent: number;
}
export interface IMonthlySpendingDTO
{
	month: number;
	totalSpent: number;
	year: number;
}
export interface ICustomerRankingDTO
{
	rankAllTime: number;
	rankThisYear: number;
	totalCustomers: number;
	totalSpentAllTime: number;
	totalSpentThisYear: number;
}
export interface ISubscriptionPlanInfoDTO
{
	cardInformation: string;
	monthlyPrice?: number;
	name: string;
	nextPayment?: any;
	previousPayment?: any;
	smsCosts?: number;
}
export abstract class ISubscriptionController
{
	static CancelSubscriptionRoute: IRouteDefinition = { url: "Subscription/cancel", method: HttpVerb.Post, queryType: "" };
	static CreateSubscriptionRoute: IRouteDefinition = { url: "Subscription/Create/current", method: HttpVerb.Post, queryType: "" };
	static GetPublishKeyRoute: IRouteDefinition = { url: "Subscription/PublicKey", method: HttpVerb.Get, queryType: "" };
	static GetSubscriptionRoute: IRouteDefinition = { url: "Subscription/current", method: HttpVerb.Get, queryType: "" };
	static StatusByUserIdRoute: IRouteDefinition = { url: "Subscription/StatusOnUser", method: HttpVerb.Get, queryType: "" };
	static StatusRoute: IRouteDefinition = { url: "Subscription/Status/current", method: HttpVerb.Get, queryType: "" };
	public abstract createSubscription(stripeEmail: string, stripeToken: string): Promise<any>;
	public abstract cancelSubscription(cancelAtTheEndOfTheMonth: boolean): Promise<any>;
	public abstract status(): Promise<string>;
	public abstract statusByUserId(userId: string): Promise<string>;
	public abstract getSubscription(): Promise<ISubscriptionPlanInfoDTO>;
	public abstract getPublishKey(): Promise<string>;
}
export abstract class IVacationDayController
{
	static AddVacationDaysRoute: IRouteDefinition = { url: "VacationDays/current", method: HttpVerb.Post, queryType: "IAddVacationDaysQuery" };
	static GetVacationDaysAnonymousRoute: IRouteDefinition = { url: "VacationDays/asAnonymous", method: HttpVerb.Get, queryType: "IGetVacationDaysAnonymousQuery" };
	static GetVacationDaysRoute: IRouteDefinition = { url: "VacationDays/current/{staffMemberId}", method: HttpVerb.Get, queryType: "" };
	static RemoveVacationDayRoute: IRouteDefinition = { url: "VacationDays/current", method: HttpVerb.Delete, queryType: "IRemoveVacationDayQuery" };
	public abstract getVacationDays(staffMemberId?: number): Promise<IVacationDayDTO[]>;
	public abstract getVacationDaysAnonymous(query: Partial<typeof IVacationDayController.IGetVacationDaysAnonymousQuery>): Promise<IVacationDayDTO[]>;
	public abstract addVacationDays(query: Partial<typeof IVacationDayController.IAddVacationDaysQuery>): Promise<void>;
	public abstract removeVacationDay(query: Partial<typeof IVacationDayController.IRemoveVacationDayQuery>): Promise<void>;
	    public static IGetVacationDaysAnonymousQuery: {
	        userId: string;
	        serviceIds: string;
	    };
	    public static IAddVacationDaysQuery: {
	        vacationDaysString: string;
	        staffMemberId: number | null;
	    };
	    public static IRemoveVacationDayQuery: {
	        vacationDaysString: string;
	        staffMemberId: number | null;
	    };
}
export abstract class IWorkingDaysController
{
	static GetAllWorkingDaysAnonymousRoute: IRouteDefinition = { url: "WorkingDays/all", method: HttpVerb.Get, queryType: "" };
	static GetAllWorkingDaysRoute: IRouteDefinition = { url: "WorkingDays/all/current", method: HttpVerb.Get, queryType: "" };
	static ToggleWorkingHourDayRoute: IRouteDefinition = { url: "WorkingDays/current", method: HttpVerb.Put, queryType: "" };
	public abstract toggleWorkingHourDay(dayOfWeek: number, isWorking: boolean, staffMemberId?: number): Promise<void>;
	public abstract getAllWorkingDays(staffMemberId?: number): Promise<boolean[]>;
	public abstract getAllWorkingDaysAnonymous(userId: string, serviceIds: string): Promise<boolean[]>;
}
export interface IAvailableHoursRequestDTO
{
	day: number;
	month: number;
	serviceBookings: IServiceBookingPostDTO[];
	staffMemberId?: number;
	userID: string;
	year: number;
}
export interface IServiceBookingPostDTO
{
}
export abstract class ICustomersController
{
	static DeleteCustomerRoute: IRouteDefinition = { url: "Customer/current", method: HttpVerb.Delete, queryType: "" };
	static GetCustomerByTokenRoute: IRouteDefinition = { url: "Customer/FetchByToken/{customerToken}/{userId}/{phoneNumber}", method: HttpVerb.Get, queryType: "" };
	static GetCustomerRoute: IRouteDefinition = { url: "Customer/current/{customerId}", method: HttpVerb.Get, queryType: "" };
	static GetCustomersRoute: IRouteDefinition = { url: "Customer/current", method: HttpVerb.Get, queryType: "" };
	static GetCustomerStatsRoute: IRouteDefinition = { url: "Customer/current/statistics/{customerId}", method: HttpVerb.Get, queryType: "" };
	static GetDetailedCustomerStatsRoute: IRouteDefinition = { url: "Customer/current/detailed-statistics/{customerId}", method: HttpVerb.Get, queryType: "" };
	static PostCustomerRoute: IRouteDefinition = { url: "Customer/current", method: HttpVerb.Post, queryType: "" };
	static PutCustomerRoute: IRouteDefinition = { url: "Customer/current", method: HttpVerb.Put, queryType: "" };
	private static formValues(firstName: string, lastName: string, phone: string, email: string, address: string, postalCode: string, city: string) : ICustomerFormValuesDTO
	{
		return null;
	}
	public abstract getCustomerByToken(customerToken: string, userId: string, phoneNumber: string): Promise<ICustomerTokenDataDTO>;
	public abstract getCustomerStats(customerId: number): Promise<ICustomerStatisticsDTO>;
	public abstract getCustomer(customerId: number): Promise<ICustomerDTO>;
	public abstract getCustomers(): Promise<ICustomerDTO[]>;
	public abstract putCustomer(customer: ICustomerDTO): Promise<any>;
	public abstract postCustomer(customer: any): Promise<void>;
	public abstract deleteCustomer(id: number): Promise<void>;
	public abstract getDetailedCustomerStats(customerId: number): Promise<ICustomerDetailedStatisticsDTO>;
}
export abstract class ICustomFieldController
{
	static DeleteRoute: IRouteDefinition = { url: "CustomField/current", method: HttpVerb.Delete, queryType: "" };
	static GetAsAnonymousRoute: IRouteDefinition = { url: "CustomField/asAnonymous/{userId}", method: HttpVerb.Get, queryType: "" };
	static GetRoute: IRouteDefinition = { url: "CustomField/current", method: HttpVerb.Get, queryType: "" };
	static PostRoute: IRouteDefinition = { url: "CustomField/current", method: HttpVerb.Post, queryType: "" };
	static PutRoute: IRouteDefinition = { url: "CustomField/current", method: HttpVerb.Put, queryType: "" };
	public abstract get(): Promise<ICustomFieldDTO[]>;
	public abstract getAsAnonymous(userId: string): Promise<ICustomFieldDTO[]>;
	public abstract put(DTO: ICustomFieldDTO): Promise<void>;
	public abstract post(DTO: ICustomFieldDTO): Promise<void>;
	public abstract delete(id: number): Promise<void>;
}
export abstract class INotificationController
{
	static DeleteNotificationRoute: IRouteDefinition = { url: "Notification/current/{id}", method: HttpVerb.Delete, queryType: "" };
	static GetNotificationRoute: IRouteDefinition = { url: "Notification/{notificationId}", method: HttpVerb.Get, queryType: "" };
	static GetNotificationsForCurrentUserRoute: IRouteDefinition = { url: "Notification/all/current", method: HttpVerb.Get, queryType: "" };
	static GetNotificationsRoute: IRouteDefinition = { url: "Notification/all", method: HttpVerb.Get, queryType: "" };
	static MarkAllNotifcationsAsReadRoute: IRouteDefinition = { url: "Notification/all/MarkAsRead/current", method: HttpVerb.Put, queryType: "" };
	static MarkNotifcationAsReadRoute: IRouteDefinition = { url: "Notification/MarkAsRead/current/{notificationId}", method: HttpVerb.Put, queryType: "" };
	static PostNotificationRoute: IRouteDefinition = { url: "Notification/current", method: HttpVerb.Post, queryType: "" };
	public abstract getNotifications(): Promise<INotificationDTO[]>;
	public abstract getNotification(notificationId: number): Promise<INotificationDTO>;
	public abstract getNotificationsForCurrentUser(): Promise<any>;
	public abstract markNotifcationAsRead(notificationId: number): Promise<void>;
	public abstract markAllNotifcationsAsRead(): Promise<void>;
	public abstract postNotification(notification: any): Promise<void>;
	public abstract deleteNotification(id: number): Promise<void>;
}
export abstract class IPauseTimeController
{
	static DeletePauseTimeRoute: IRouteDefinition = { url: "PauseTimes/current", method: HttpVerb.Delete, queryType: "" };
	static GetPauseTimesRoute: IRouteDefinition = { url: "PauseTimes/current", method: HttpVerb.Get, queryType: "" };
	static PostPauseTimeRoute: IRouteDefinition = { url: "PauseTimes/current", method: HttpVerb.Post, queryType: "" };
	public abstract getPauseTimes(staffMemberId?: number): Promise<ISimplePauseTimeDTO[]>;
	public abstract postPauseTime(pauseTime: IPostPauseTimeDTO): Promise<ISimplePauseTimeDTO[]>;
	public abstract deletePauseTime(id: number): Promise<ISimplePauseTimeDTO[]>;
}
export abstract class IResourceController
{
	static AddResourceRoute: IRouteDefinition = { url: "Resources/current", method: HttpVerb.Post, queryType: "" };
	static AddServiceRoute: IRouteDefinition = { url: "Resources/current/service/{resourceId}/{serviceId}", method: HttpVerb.Put, queryType: "" };
	static DeleteResourceRoute: IRouteDefinition = { url: "Resources/current/{resourceId}", method: HttpVerb.Delete, queryType: "" };
	static EditResourceRoute: IRouteDefinition = { url: "Resources/current", method: HttpVerb.Put, queryType: "" };
	static GetResourcesRoute: IRouteDefinition = { url: "Resources/current", method: HttpVerb.Get, queryType: "" };
	public abstract getResources(): Promise<IResourceDTO[]>;
	public abstract editResource(resourceDTO: IResourceDTO): Promise<void>;
	public abstract addResource(resourceDTO: IPostResourceDTO): Promise<void>;
	public abstract deleteResource(resourceId: number): Promise<void>;
	public abstract addService(resourceId: number, serviceId: number): Promise<void>;
}
export abstract class IServiceCategoryController
{
	static ChangeOrderForCategoryRoute: IRouteDefinition = { url: "ServiceCategory/changeOrder/current", method: HttpVerb.Put, queryType: "" };
	static DeleteCategoryRoute: IRouteDefinition = { url: "ServiceCategory/current", method: HttpVerb.Delete, queryType: "" };
	static EditCategoryRoute: IRouteDefinition = { url: "ServiceCategory/current", method: HttpVerb.Put, queryType: "" };
	static GetCategoriesForAdminRoute: IRouteDefinition = { url: "ServiceCategory/current", method: HttpVerb.Get, queryType: "" };
	static PostCategoryRoute: IRouteDefinition = { url: "ServiceCategory/current", method: HttpVerb.Post, queryType: "" };
	public abstract getCategoriesForAdmin(): Promise<IServiceCategoryDTO[]>;
	public abstract changeOrderForCategory(categoryId: number, order: number): Promise<void>;
	public abstract postCategory(category: IServiceCategoryDTO): Promise<void>;
	public abstract editCategory(category: IPostServiceCategoryDTO): Promise<void>;
	public abstract deleteCategory(id: number): Promise<void>;
}
export abstract class IServiceController
{
	static AssignAppointmentTypeToUserRoute: IRouteDefinition = { url: "Service/AssignOrUnAssign/current", method: HttpVerb.Post, queryType: "" };
	static ChangeExtraServiceRoute: IRouteDefinition = { url: "Service/changeExtraService/current", method: HttpVerb.Put, queryType: "" };
	static ChangeOrderForServiceRoute: IRouteDefinition = { url: "Service/changeOrder/current", method: HttpVerb.Put, queryType: "" };
	static DeleteTreatmentTypeRoute: IRouteDefinition = { url: "Service/current", method: HttpVerb.Delete, queryType: "" };
	static EditServiceRoute: IRouteDefinition = { url: "Service/current", method: HttpVerb.Put, queryType: "" };
	static GetServicesAsAnonymousRoute: IRouteDefinition = { url: "Service/asAnonymous", method: HttpVerb.Get, queryType: "" };
	static GetServicesRoute: IRouteDefinition = { url: "Service/current", method: HttpVerb.Get, queryType: "IGetServicesQuery" };
	static GetTreatmentTypeRoute: IRouteDefinition = { url: "Service/{appointmentTypeId}", method: HttpVerb.Get, queryType: "" };
	static PostServiceRoute: IRouteDefinition = { url: "Service/current", method: HttpVerb.Post, queryType: "" };
	static PutAppointmentTypeRoute: IRouteDefinition = { url: "Service/changeCategoryOrder/current", method: HttpVerb.Put, queryType: "" };
	public abstract getTreatmentType(appointmentTypeId: number): Promise<any>;
	public abstract changeExtraService(extraServiceChange: any): Promise<void>;
	public abstract getServices(query: Partial<typeof IServiceController.IGetServicesQuery>): Promise<IAppointmentTypeDTO[]>;
	public abstract getServicesAsAnonymous(userId: string): Promise<IServiceGroupForBookingDTO[]>;
	public abstract putAppointmentType(id: number, categoryId: number, order: number): Promise<void>;
	public abstract changeOrderForService(serviceId: number, order: number): Promise<void>;
	public abstract editService(treatmentType: IAppointmentTypeDTO): Promise<void>;
	public abstract postService(treatmentType: IAppointmentTypeDTO): Promise<any>;
	public abstract assignAppointmentTypeToUser(treatmentTypeId: number): Promise<void>;
	public abstract deleteTreatmentType(id: number): Promise<void>;
	    public static IGetServicesQuery: {
	        extra: string | null;
	    };
}
export interface ICalendarInterval
{
	closeHour: number;
	closeMinute: number;
	openHour: number;
	openMinute: number;
}
export interface IWeekDayOpeningTimes
{
	closeMinutesFromMidnight: number;
	openMinutesFromMidnight: number;
}
export interface ICachedAvailableHours
{
	day: number;
	hoursToBook: IHourToBookDTO[];
	month: number;
	year: number;
}
export interface IPreLoadedHourToBookDTO extends ILoadedHourToBookDTO
{
}
export interface ILoadedHourToBookDTO
{
	day: number;
	hoursToBook: IHourToBookDTO[];
	id: string;
	iso: string;
	month: number;
	year: number;
}
export interface IHourToBookDTO
{
	appointmentEndLabel: string;
	backendLabel: string;
	customerAppointmentEndLabel: string;
	date: any;
	label: string;
	getAppointmentEnd(length: number) : any;
}
export interface IMoneyAccountSummaryDTO
{
	accountBalances: IAccountBalanceDTO[];
	totalBalance: number;
	totalIncomingToday: number;
	totalNetChangeToday: number;
	totalOutgoingToday: number;
}
export interface IAccountBalanceDTO
{
	accountId: number;
	accountName: string;
	todayIncoming: number;
	todayNetChange: number;
	todayOutgoing: number;
	totalBalance: number;
}
export interface ILedgerEntryDTO
{
	amount: number;
	customerId: number;
	dateTime?: any;
	description: string;
	id: number;
	moneyAccountId?: number;
	sourceId: number;
	sourceType: LedgerEntrySourceType;
	status: LedgerEntryStatus;
	type: LedgerEntryType;
}
export interface ILedgerEntryDetailsDTO
{
	appointment: IAppointmentInfoDTO;
	ledgerEntry: ILedgerEntryDTO;
}
export interface ICreateAppointmentLedgerEntryDTO
{
	appointmentId: number;
}
export interface ICreateOrderLedgerEntryDTO
{
	orderId: number;
}
export interface IMoneyAccountDTO
{
	description: string;
	id: number;
	name: string;
	paymentMethod: PaymentMethod;
}
export interface IPostMoneyAccountDTO
{
	description: string;
	name: string;
	paymentMethod: PaymentMethod;
}
export interface IOrderDTO
{
	appointmentId?: number;
	createdAt: any;
	customerId: number;
	id: number;
	number: number;
	orderDate: any;
	paymentMethod: PaymentMethod;
	salesItems: ISalesItemDTO[];
	staffId: number;
	status: OrderStatus;
	totalAmount: number;
	updatedAt?: any;
	useLedgerEntry: boolean;
}
export interface ISalesItemDTO
{
	createdAt: any;
	id: number;
	inventoryItemId: number;
	orderDate: any;
	orderId: number;
	price: number;
	quantity: number;
	totalPrice: number;
	updatedAt: any;
}
export interface ILedgerPaymentDTO
{
	allocations: IPaymentAllocationDTO[];
	amount: number;
	createdAt: any;
	customerId: string;
	dateTime: any;
	id: number;
	paymentMethod: PaymentMethod;
	reference: string;
}
export interface IPaymentAllocationDTO
{
	amount: number;
	createdAt: any;
	id: number;
	ledgerEntryId: number;
	ledgerPaymentId: number;
}
export abstract class IExpenseController
{
	static CreateOneTimeRoute: IRouteDefinition = { url: "Expense/current/onetime", method: HttpVerb.Post, queryType: "" };
	static CreateRecurringRoute: IRouteDefinition = { url: "Expense/current/recurring", method: HttpVerb.Post, queryType: "" };
	static DeleteOneTimeRoute: IRouteDefinition = { url: "Expense/current/onetime/{id}", method: HttpVerb.Delete, queryType: "" };
	static DeleteRecurringRoute: IRouteDefinition = { url: "Expense/current/recurring/{id}", method: HttpVerb.Delete, queryType: "" };
	static EditOneTimeRoute: IRouteDefinition = { url: "Expense/current/onetime/{id}", method: HttpVerb.Put, queryType: "" };
	static EditRecurringRoute: IRouteDefinition = { url: "Expense/current/recurring/{id}", method: HttpVerb.Put, queryType: "" };
	static GetAllOneTimeRoute: IRouteDefinition = { url: "Expense/current/onetime", method: HttpVerb.Get, queryType: "" };
	static GetAllRecurringRoute: IRouteDefinition = { url: "Expense/current/recurring", method: HttpVerb.Get, queryType: "" };
	static GetSingleOneTimeRoute: IRouteDefinition = { url: "Expense/current/onetime/{id}", method: HttpVerb.Get, queryType: "" };
	static GetSingleRecurringRoute: IRouteDefinition = { url: "Expense/current/recurring/{id}", method: HttpVerb.Get, queryType: "" };
	public abstract getAllRecurring(): Promise<IRecurringExpenseDTO[]>;
	public abstract getAllOneTime(): Promise<IOneTimeExpenseDTO[]>;
	public abstract getSingleRecurring(id: number): Promise<IRecurringExpenseDTO>;
	public abstract getSingleOneTime(id: number): Promise<IOneTimeExpenseDTO>;
	public abstract createRecurring(dto: any): Promise<IRecurringExpenseDTO>;
	public abstract createOneTime(dto: IPostOneTimeExpenseDTO): Promise<IOneTimeExpenseDTO>;
	public abstract deleteOneTime(id: number): Promise<any>;
	public abstract deleteRecurring(id: number): Promise<any>;
	public abstract editOneTime(id: number, dto: IPostOneTimeExpenseDTO): Promise<IOneTimeExpenseDTO>;
	public abstract editRecurring(id: number, dto: any): Promise<IRecurringExpenseDTO>;
}
export abstract class IMoneyAccountController
{
	static CreateRoute: IRouteDefinition = { url: "MoneyAccount/current", method: HttpVerb.Post, queryType: "" };
	static DeleteRoute: IRouteDefinition = { url: "MoneyAccount/current/{id}", method: HttpVerb.Delete, queryType: "" };
	static GetAllRoute: IRouteDefinition = { url: "MoneyAccount/current", method: HttpVerb.Get, queryType: "" };
	static GetByIdRoute: IRouteDefinition = { url: "MoneyAccount/current/{id}", method: HttpVerb.Get, queryType: "" };
	static GetSummaryRoute: IRouteDefinition = { url: "MoneyAccount/current/summary", method: HttpVerb.Get, queryType: "IGetSummaryQuery" };
	static UpdateRoute: IRouteDefinition = { url: "MoneyAccount/current/{id}", method: HttpVerb.Put, queryType: "" };
	public abstract getAll(): Promise<IMoneyAccountDTO[]>;
	public abstract getById(id: number): Promise<IMoneyAccountDTO>;
	public abstract create(dto: IPostMoneyAccountDTO): Promise<IMoneyAccountDTO>;
	public abstract update(id: number, dto: IPostMoneyAccountDTO): Promise<IMoneyAccountDTO>;
	public abstract delete(id: number): Promise<any>;
	public abstract getSummary(query: Partial<typeof IMoneyAccountController.IGetSummaryQuery>): Promise<IMoneyAccountSummaryDTO>;
	    public static IGetSummaryQuery: {
	        year: number | null;
	        month: number | null;
	        day: number | null;
	    };
}
export abstract class IOrderController
{
	static CreateOrderRoute: IRouteDefinition = { url: "Order/current", method: HttpVerb.Post, queryType: "" };
	static GetOrderRoute: IRouteDefinition = { url: "Order/current/{id}", method: HttpVerb.Get, queryType: "" };
	static GetOrdersByCustomerIdRoute: IRouteDefinition = { url: "Order/current/customer/{customerId}", method: HttpVerb.Get, queryType: "" };
	static GetOrdersRoute: IRouteDefinition = { url: "Order/current", method: HttpVerb.Get, queryType: "" };
	static ProcessPaymentRoute: IRouteDefinition = { url: "Order/current/payment", method: HttpVerb.Post, queryType: "" };
	public abstract createOrder(dto: IPostOrderDTO): Promise<IOrderDTO>;
	public abstract processPayment(dto: IPostLedgerPaymentDTO): Promise<ILedgerPaymentDTO>;
	public abstract getOrders(): Promise<IOrderDTO[]>;
	public abstract getOrder(id: number): Promise<IOrderDTO>;
	public abstract getOrdersByCustomerId(customerId: number): Promise<IOrderDTO[]>;
}
export interface IInventoryItemRoutes
{
}
export const enum PermissionLevel {
	None = 0,
	Read = 1,
	ReadWrite = 2
}
export interface IPauseTimeDTO
{
	dayOfWeek: number;
	endFromMidNight: number;
	id: number;
	staffId: number;
	startFromMidNight: number;
}
export interface IPostPauseTimeDTO
{
	dayOfWeek: number;
	end: string;
	staffId: number;
	start: string;
}
export interface ISimplePauseTimeDTO
{
	dayOfWeek: number;
	end: string;
	id: number;
	staffId: number;
	start: string;
}
export interface IEmailListEntryDTO
{
	email: string;
	id: number;
	name: string;
	signupDate: any;
}
export interface IServiceGroupForBookingDTO
{
	order?: number;
	services: IAppointmentTypeDTO[];
	title: string;
}
export enum PaymentMethod {
	Cash = 0,
	Card = 1,
	Transfer = 2,
	Other = 3
}
export enum GiftCardRedemptionChannel {
	Pos = 0,
	Online = 1
}
export enum GiftCardStatus {
	Generated = 0,
	Printed = 1,
	Active = 2,
	Redeemed = 3,
	PartiallyRedeemed = 4,
	Expired = 5,
	Voided = 6
}
export enum CommissionStatus {
	Unpaid = 0,
	Paid = 1,
	Voided = 2
}
export enum LedgerEntrySourceType {
	Appointment = 0,
	Order = 1,
	Manual = 2,
	RecurringExpense = 3,
	Expense = 4,
	Commission = 5
}
export enum LedgerEntryStatus {
	Unpaid = 0,
	PartiallyPaid = 1,
	Paid = 2,
	Voided = 3
}
export enum LedgerEntryType {
	Charge = 0,
	Payment = 1,
	Refund = 2,
	Adjustment = 3
}
export enum OrderStatus {
	Pending = 0,
	Completed = 1,
	Cancelled = 2,
	Refunded = 3
}
export enum ExpenseCategory {
	Inventory = 0,
	Salaries = 1,
	Rent = 2,
	Utilities = 3,
	Other = 4,
	Commission = 5
}
export enum RecurrenceInterval {
	Daily = 0,
	Weekly = 1,
	Monthly = 2,
	Quarterly = 3,
	Yearly = 4
}
export enum OnlineTransactionProvider {
	None = 0,
	PayU = 1,
	Stripe = 2,
	Vipps = 3
}
export interface ICommissionDTO
{
	amount: number;
	createdAt: any;
	date: any;
	id: number;
	moneyAccountId?: number;
	paidAt?: any;
	staffId: number;
	staffName: string;
	status: CommissionStatus;
}
export interface ICreateCommissionDTO
{
	amount: number;
	date: any;
	description: string;
	moneyAccountId?: number;
	staffId: number;
}
export interface IAccountRoleDTO
{
	administration: PermissionLevel;
	appointmentsAndClients: PermissionLevel;
	id: number;
	name: string;
	settings: PermissionLevel;
	statisticsAndFinances: PermissionLevel;
}
export interface IAppointmentFormDTO
{
	allowCustomEvent: boolean;
	appointmentId: number;
	canCreateCustomer: boolean;
	giftCards: IAppointmentFormGiftCardsDTO;
	labels: IAppointmentFormLabelsDTO;
	multipleServices: boolean;
	payment: IAppointmentFormPaymentDTO;
	quote: IAppointmentFormQuoteDTO;
	services: IAppointmentFormServiceDTO[];
	showPrice: boolean;
	staffOptions: IScreenOptionDTO[];
	startTimes: IScreenOptionDTO[];
	title: string;
	values: IAppointmentFormValuesDTO;
}
export interface IAppointmentFormGiftCardsDTO
{
	addText: string;
	enabled: boolean;
	texts: IAppointmentGiftCardTextsDTO;
	title: string;
}
export interface IAppointmentFormGiftCardDTO
{
	amount: number;
	code: string;
	notes: string;
}
export interface IAppointmentFormQuoteGiftCardsDTO
{
	amountOverRemaining: string;
	remainingPayable: number;
	remainingText: string;
	rows: IAppointmentFormGiftCardRowDTO[];
}
export interface IAppointmentFormGiftCardRowDTO
{
	code: string;
	text: string;
}
export interface IAppointmentFormPaymentDTO
{
	accountLabel: string;
	accounts: IScreenOptionDTO[];
	amountLabel: string;
	enabled: boolean;
	label: string;
	statuses: ICalendarOptionDTO[];
}
export interface IAppointmentFormValuesDTO
{
	customerId: number;
	customerLabel: string;
	date: string;
	description: string;
	durationMinutes: number;
	isCustom: boolean;
	price?: number;
	serviceIds: number[];
	staffMemberId: number;
	startMinute: number;
}
export interface IAppointmentFormServiceDTO
{
	category: string;
	detail: string;
	durationMinutes: number;
	eligibleForCustomPrice: boolean;
	id: number;
	label: string;
	price: number;
}
export interface IAppointmentFormLabelsDTO
{
	customer: string;
	customEvent: string;
	date: string;
	description: string;
	dropIn: string;
	end: string;
	freeTime: string;
	newCustomer: string;
	noCategory: string;
	price: string;
	save: string;
	searchCustomers: string;
	searchServices: string;
	services: string;
	staff: string;
	start: string;
}
export interface IAppointmentFormRequestDTO
{
	adminNote: string;
	appointmentId: number;
	customerId: number;
	customerName: string;
	date: string;
	description: string;
	durationMinutes?: number;
	emailReminder?: boolean;
	force?: boolean;
	giftCards: IAppointmentFormGiftCardDTO[];
	isCustom: boolean;
	moneyAccountId?: number;
	partialPaymentAmount?: number;
	paymentStatus: string;
	price?: number;
	serviceIds: number[];
	smsReminder?: boolean;
	staffMemberId: number;
	startMinute: number;
}
export interface IAppointmentFormQuoteDTO
{
	autoStaffMemberId: number;
	defaultPrice: number;
	durationMinutes: number;
	durationText: string;
	endMinute: number;
	endText: string;
	endTimes: IScreenOptionDTO[];
	freeStartTimes: IScreenOptionDTO[];
	giftCards: IAppointmentFormQuoteGiftCardsDTO;
	invalid: string;
	overlaps: boolean;
	priceText: string;
	reminders: IAppointmentFlowRemindersDTO;
	skipStaffStep: boolean;
	staffChoices: IScreenOptionDTO[];
	startTimes: IScreenOptionDTO[];
	summary: IAppointmentFlowSummaryRowDTO[];
	warnings: string[];
}
export interface IAppointmentFormSavedDTO
{
	appointmentId: number;
	number: number;
}
export interface IAppointmentBookingFlowDTO
{
	days: IAppointmentFlowDayDTO[];
	form: IAppointmentFormDTO;
	labels: IAppointmentFlowLabelsDTO;
	recentCustomers: IScreenOptionDTO[];
	steps: IAppointmentFlowStepDTO[];
}
export interface IAppointmentFlowStepDTO
{
	key: string;
	preset: boolean;
	title: string;
}
export interface IAppointmentFlowDayDTO
{
	date: string;
	day: string;
	weekday: string;
}
export interface IAppointmentFlowSummaryRowDTO
{
	label: string;
	step: string;
	text: string;
}
export interface IAppointmentFlowRemindersDTO
{
	available: boolean;
	email: boolean;
	sms: boolean;
}
export interface IAppointmentFlowLabelsDTO
{
	book: string;
	discard: string;
	discardMessage: string;
	discardTitle: string;
	emailReminder: string;
	next: string;
	noFreeTimes: string;
	note: string;
	recentCustomers: string;
	reminders: string;
	smsReminder: string;
	stepOf: string;
	summary: string;
}
export interface IAppointmentListScreenDTO
{
	canWrite: boolean;
	columns: IScreenColumnDTO[];
	customerId: number;
	desc: boolean;
	emptyText: string;
	from: string;
	page: number;
	pageCount: number;
	pageSize: number;
	rows: IAppointmentListRowDTO[];
	search: string;
	sort: string;
	sortOptions: IAppointmentSortOptionDTO[];
	staffMemberId: number;
	staffOptions: IScreenOptionDTO[];
	statuses: string[];
	statusOptions: IAppointmentStatusDTO[];
	texts: IAppointmentListTextsDTO;
	title: string;
	to: string;
	total: number;
	totalText: string;
}
export interface IAppointmentListRowDTO
{
	actions: IAppointmentRowActionsDTO;
	adminNote: string;
	comment: string;
	created: string;
	customerId?: number;
	customerName: string;
	date: string;
	id: number;
	number: number;
	numberText: string;
	service: string;
	staffName: string;
	status: IAppointmentStatusDTO;
	time: string;
}
export interface IAppointmentRowActionsDTO
{
	changeStatus: boolean;
	delete: boolean;
	editNote: boolean;
}
export interface IAppointmentStatusDTO
{
	code: string;
	color: string;
	label: string;
	textColor: string;
}
export interface IAppointmentSortOptionDTO
{
	label: string;
	value: string;
}
export interface IAppointmentListTextsDTO
{
	adminNote: string;
	comment: string;
	deleteSelected: string;
	deleteSelectedMessage: string;
	deleteSelectedTitle: string;
	filter: string;
	search: string;
	sort: string;
	staff: string;
}
export interface IAppointmentPageScreenDTO
{
	actions: IAppointmentPageActionsDTO;
	adminNote: string;
	cards: IAppointmentCardDTO[];
	date: string;
	giftCards: IAppointmentGiftCardsDTO;
	id: number;
	isCustom: boolean;
	number: number;
	status: IAppointmentStatusDTO;
	statusOptions: IAppointmentStatusDTO[];
	texts: IAppointmentPageTextsDTO;
	title: string;
}
export interface IAppointmentCardDTO
{
	customerId?: number;
	key: string;
	label: string;
	text: string;
}
export interface IAppointmentPageActionsDTO
{
	changeStatus: boolean;
	delete: boolean;
	edit: boolean;
	editNote: boolean;
	findInCalendar: boolean;
	redeemGiftCard: boolean;
}
export interface IAppointmentPageTextsDTO
{
	adminNote: string;
	delete: string;
	deleted: string;
	deleteMessage: string;
	deleteTitle: string;
	edit: string;
	findInCalendar: string;
	status: string;
}
export interface IAppointmentGiftCardsDTO
{
	addText: string;
	canRedeem: boolean;
	description: string;
	emptyText: string;
	enabled: boolean;
	priceText: string;
	redeemedText: string;
	redemptions: IAppointmentGiftCardRedemptionRowDTO[];
	remainingPayable: number;
	remainingText: string;
	texts: IAppointmentGiftCardTextsDTO;
	title: string;
}
export interface IAppointmentGiftCardRedemptionRowDTO
{
	amountText: string;
	code: string;
	details: string;
	text: string;
}
export interface IAppointmentGiftCardTextsDTO
{
	amount: string;
	amountOverBalance: string;
	amountOverRemaining: string;
	amountTooLow: string;
	balance: string;
	code: string;
	notes: string;
	redeem: string;
	redeemed: string;
	searchPrompt: string;
}
export interface IAppointmentGiftCardSearchDTO
{
	cards: IAppointmentGiftCardOptionDTO[];
	message: string;
	remainingPayable: number;
	remainingText: string;
}
export interface IAppointmentGiftCardOptionDTO
{
	balance: number;
	balanceText: string;
	code: string;
	defaultAmount: number;
	subtitle: string;
}
export interface IAppointmentStatusChangeDTO
{
	status: string;
}
export interface IAppointmentAdminNoteDTO
{
	note: string;
}
export interface IAppointmentArchiveRequestDTO
{
	ids: number[];
}
export interface IAppointmentArchiveResultDTO
{
	archived: number;
	message: string;
}
export interface IAppointmentGiftCardRedeemDTO
{
	amount: number;
	code: string;
	notes: string;
}
export interface IAvailableDayRequestDTO
{
	day: number;
	month: number;
	serviceIds: number[];
	userId: string;
	year: number;
}
export interface IMoveAppointmentDTO
{
	date: string;
	durationMinutes?: number;
	force?: boolean;
	staffMemberId?: number;
	startMinute: number;
}
export interface IActionErrorDTO
{
	code: string;
	message: string;
}
export interface ICalendarScreenDTO
{
	canCreate: boolean;
	columns: ICalendarColumnDTO[];
	date: string;
	events: ICalendarEventDTO[];
	grid: ICalendarGridDTO;
	nextDate: string;
	previousDate: string;
	regions: ICalendarRegionDTO[];
	staffMemberId: number;
	staffOptions: IScreenOptionDTO[];
	title: string;
	todayDate: string;
	view: string;
	viewOptions: ICalendarOptionDTO[];
	weekdayLabels: string[];
	weeks: ICalendarMonthWeekDTO[];
}
export interface ICalendarOptionDTO
{
	label: string;
	value: string;
}
export interface ICalendarGridDTO
{
	endMinute: number;
	startMinute: number;
	twelveHourClock: boolean;
}
export interface ICalendarColumnDTO
{
	closed: boolean;
	date: string;
	isToday: boolean;
	key: string;
	label: string;
	staffMemberId: number;
}
export interface ICalendarRegionDTO
{
	columnKey: string;
	endMinute: number;
	kind: string;
	startMinute: number;
}
export interface ICalendarEventDTO
{
	actions: ICalendarEventActionsDTO;
	color: string;
	columnKey: string;
	date: string;
	endMinute: number;
	giftCard: boolean;
	hasAdminNote: boolean;
	hasComment: boolean;
	id: number;
	isCustom: boolean;
	lane: number;
	laneCount: number;
	lines: string[];
	number: number;
	onlineBooking: boolean;
	staffMemberId: number;
	startMinute: number;
	status: string;
	textColor: string;
	title: string;
}
export interface ICalendarEventActionsDTO
{
	delete: boolean;
	edit: boolean;
	editNote: boolean;
	move: boolean;
	resize: boolean;
}
export interface ICalendarMonthWeekDTO
{
	days: ICalendarMonthDayDTO[];
}
export interface ICalendarMonthDayDTO
{
	closed: boolean;
	date: string;
	dayNumber: number;
	events: ICalendarMonthEventDTO[];
	inMonth: boolean;
	isToday: boolean;
	moreCount: number;
}
export interface ICalendarMonthEventDTO
{
	color: string;
	id: number;
	textColor: string;
	time: string;
	title: string;
}
export interface ICalendarAppointmentDTO
{
	actions: ICalendarEventActionsDTO;
	adminNote: string;
	adminNoteLabel: string;
	assignStaffOptions: IScreenOptionDTO[];
	badges: ICalendarBadgeDTO[];
	color: string;
	customerId: number;
	date: string;
	endMinute: number;
	id: number;
	isCustom: boolean;
	number: number;
	rows: ICalendarDetailRowDTO[];
	staffMemberId: number;
	startMinute: number;
	textColor: string;
	timeText: string;
	title: string;
}
export interface ICalendarBadgeDTO
{
	key: string;
	label: string;
}
export interface ICalendarDetailRowDTO
{
	key: string;
	kind: string;
	label: string;
	value: string;
}
export interface ICustomerListScreenDTO
{
	actions: ICustomerActionsDTO;
	columns: IScreenColumnDTO[];
	deleteMessage: string;
	deleteSelectedMessage: string;
	deleteSelectedTitle: string;
	deleteTitle: string;
	desc: boolean;
	emptyText: string;
	page: number;
	pageCount: number;
	pageSize: number;
	rows: ICustomerListRowDTO[];
	search: string;
	searchPlaceholder: string;
	sort: string;
	sortOptions: ICalendarOptionDTO[];
	title: string;
	total: number;
	totalText: string;
}
export interface ICustomerListRowDTO
{
	address: string;
	createdLine: string;
	createdText: string;
	email: string;
	hasName: boolean;
	id: number;
	name: string;
	owedText: string;
	owes: boolean;
	phone: string;
}
export interface ICustomerDeleteRequestDTO
{
	ids: number[];
}
export interface ICustomerDeleteResultDTO
{
	deleted: number;
	message: string;
}
export interface ICustomerActionsDTO
{
	addLedgerEntry: boolean;
	create: boolean;
	delete: boolean;
	edit: boolean;
	editNotes: boolean;
}
export interface ICustomerPageScreenDTO
{
	actions: ICustomerActionsDTO;
	deleteMessage: string;
	deleteTitle: string;
	highlights: ICustomerCardDTO[];
	id: number;
	journal: ICustomerJournalEntryDTO[];
	notes: ICustomerNotesDTO;
	sections: ICustomerSectionDTO[];
	subtitle: string;
	tabs: ICalendarOptionDTO[];
	title: string;
}
export interface ICustomerCardDTO
{
	key: string;
	label: string;
	text: string;
	tone: string;
}
export interface ICustomerSectionDTO
{
	fields: ICustomerFieldDTO[];
	key: string;
	title: string;
}
export interface ICustomerFieldDTO
{
	key: string;
	label: string;
	links: ICustomerLinkDTO[];
	value: string;
}
export interface ICustomerLinkDTO
{
	kind: string;
	label: string;
	url: string;
}
export interface ICustomerNotesDTO
{
	failedText: string;
	label: string;
	placeholder: string;
	savedText: string;
	savingText: string;
	text: string;
}
export interface ICustomerJournalEntryDTO
{
	content: string;
	dateText: string;
	id: number;
	title: string;
}
export interface ICustomerNotesUpdateDTO
{
	notes: string;
}
export interface ICustomerNotesSavedDTO
{
	notes: string;
	savedText: string;
}
export interface ICustomerLedgerScreenDTO
{
	canCreate: boolean;
	cards: ICustomerCardDTO[];
	columns: IScreenColumnDTO[];
	customerId: number;
	desc: boolean;
	emptyText: string;
	entries: ICustomerLedgerEntryDTO[];
	form: ICustomerLedgerFormDTO;
	noMatchesText: string;
	search: string;
	searchPlaceholder: string;
	sort: string;
	sortOptions: ICalendarOptionDTO[];
}
export interface ICustomerLedgerEntryDTO
{
	amountText: string;
	color: string;
	dateText: string;
	description: string;
	details: ICustomerFieldDTO[];
	id: number;
	moneyAccount: string;
	opens: string;
	rowColor: string;
	sourceId: number;
	sourceKind: string;
	sourceLabel: string;
	statusLabel: string;
	type: string;
	typeLabel: string;
	voided: boolean;
}
export interface ICustomerLedgerFormDTO
{
	amountLabel: string;
	defaultType: number;
	descriptionLabel: string;
	moneyAccountLabel: string;
	moneyAccounts: IScreenOptionDTO[];
	moneyAccountTypes: number[];
	submitLabel: string;
	title: string;
	typeLabel: string;
	types: IScreenOptionDTO[];
}
export interface ICustomerLedgerSourceDTO
{
	fields: ICustomerFieldDTO[];
	itemColumns: IScreenColumnDTO[];
	items: ICustomerLedgerSourceItemDTO[];
	itemsTitle: string;
	kind: string;
	title: string;
	totalLabel: string;
	totalText: string;
}
export interface ICustomerLedgerSourceItemDTO
{
	name: string;
	priceText: string;
	quantityText: string;
	totalText: string;
}
export interface ICustomerLedgerEntryCreateDTO
{
	amount: number;
	description: string;
	moneyAccountId?: number;
	type: number;
}
export interface ICustomerStatisticsScreenDTO
{
	charts: ICustomerChartDTO[];
	customerId: number;
	groups: ICustomerKpiGroupDTO[];
}
export interface ICustomerKpiGroupDTO
{
	key: string;
	kpis: ICustomerCardDTO[];
	title: string;
}
export interface ICustomerChartDTO
{
	emptyText: string;
	key: string;
	kind: string;
	labels: string[];
	texts: string[];
	title: string;
	values: number[];
}
export interface ICustomerFormDTO
{
	fields: ICustomerFormFieldDTO[];
	id: number;
	submitLabel: string;
	title: string;
}
export interface ICustomerFormFieldDTO
{
	key: string;
	kind: string;
	label: string;
	on: boolean;
	required: boolean;
	value: string;
}
export interface ICustomerFormValuesDTO
{
	address: string;
	city: string;
	emailAddress: string;
	firstName: string;
	lastName: string;
	phoneNumber: string;
	postalCode: string;
	sendEmailReminder: boolean;
	sendSmsReminder: boolean;
}
export interface ICustomerSavedDTO
{
	id: number;
	name: string;
}
export interface IScreenValidationErrorDTO
{
	field: string;
	message: string;
}
export interface IDailyProfitDTO
{
	earnings: number[];
	netProfit: number[];
	oneTimeExpenses: number[];
	recurringExpenses: number[];
	totalEarnings: number;
	totalExpenses: number[];
	totalExpensesSum: number;
	totalNetProfit: number;
	totalOneTimeExpenses: number;
	totalRecurringExpenses: number;
}
export interface IDashboardScreenDTO
{
	agenda: IDashboardAgendaDTO;
	date: string;
	kpis: IScreenKpiDTO[];
}
export interface IDashboardAgendaDTO
{
	allDone: boolean;
	appointments: IDashboardAppointmentDTO[];
	canCreate: boolean;
	commentTitle: string;
	doneLabel: string;
	emptyText: string;
	newAppointmentLabel: string;
	noteTitle: string;
	progressPercent: number;
	readCommentLabel: string;
	readNoteLabel: string;
	title: string;
}
export interface IDashboardAppointmentDTO
{
	adminNote: string;
	color: string;
	comment: string;
	customerId: number;
	done: boolean;
	giftCardText: string;
	id: number;
	isBlocked: boolean;
	lines: string[];
	number: number;
	textColor: string;
	timeText: string;
	title: string;
	toggleStatus: string;
}
export interface IDashboardFieldDTO
{
	label: string;
	value: string;
}
export interface IDashboardReadDTO
{
	kind: string;
}
export interface IFirebaseUserDTO
{
	email: string;
	metadata: any;
	name: string;
	phoneNumber: string;
	role: IAccountRoleDTO;
	staffMember: IStaffMemberDTO;
	userId: string;
}
export interface IFormsMetadataDTO
{
	forms: { [key:string]: IFieldMetadata[] };
}
export interface IGiftCardTypeDTO
{
	createdAt: any;
	currency: string;
	durationDays?: number;
	id: number;
	isActive: boolean;
	name: string;
	updatedAt?: any;
	value: number;
}
export interface IUpsertGiftCardTypeDTO
{
	currency: string;
	durationDays?: number;
	id?: number;
	isActive: boolean;
	name: string;
	value: number;
}
export interface IGiftCardBatchDTO
{
	createdAt: any;
	exportedAt?: any;
	giftCards: IGiftCardDTO[];
	giftCardType: IGiftCardTypeDTO;
	giftCardTypeId: number;
	id: number;
	name: string;
	notes: string;
	printedAt?: any;
	quantity: number;
}
export interface IGenerateGiftCardBatchDTO
{
	giftCardTypeId: number;
	name: string;
	notes: string;
	quantity: number;
}
export interface IGiftCardDTO
{
	balance: number;
	code: string;
	createdAt: any;
	currency: string;
	customerId?: number;
	expiryAt?: any;
	giftCardBatchId?: number;
	giftCardType: IGiftCardTypeDTO;
	giftCardTypeId: number;
	id: number;
	initialValue: number;
	notes: string;
	orderId?: number;
	printedAt?: any;
	redeemedAt?: any;
	redemptionCount: number;
	redemptions: IGiftCardRedemptionDTO[];
	soldAt?: any;
	status: GiftCardStatus;
}
export interface IGiftCardRedemptionDTO
{
	amount: number;
	appointmentId?: number;
	balanceAfter: number;
	balanceBefore: number;
	channel: GiftCardRedemptionChannel;
	giftCardId: number;
	id: number;
	notes: string;
	orderId?: number;
	processedByStaffId?: number;
	redeemedAt: any;
}
export interface ISellGiftCardsRequestDTO
{
	codes: string[];
	customerId?: number;
	notes: string;
	orderId?: number;
	soldAt?: any;
	staffId?: number;
}
export interface IRedeemGiftCardRequestDTO
{
	amount: number;
	appointmentId?: number;
	channel: GiftCardRedemptionChannel;
	code: string;
	customerId?: number;
	notes: string;
	orderId?: number;
	staffId?: number;
}
export interface IPostGiftCardRedemptionDTO
{
	amount: number;
	code: string;
	notes: string;
}
export interface IMonthlyProfitDTO
{
	dailyEarnings: number[];
	dailyNetProfit: number[];
	dailyOneTimeExpenses: number[];
	dailyRecurringExpenses: number[];
	dailyTotalExpenses: number[];
	totalEarnings: number;
	totalExpensesSum: number;
	totalNetProfit: number;
	totalOneTimeExpenses: number;
	totalRecurringExpenses: number;
}
export interface IPosFormDTO
{
	canCreateCustomer: boolean;
	canSave: boolean;
	categories: IPosCategoryDTO[];
	customerId: number;
	customerLabel: string;
	giftCards: IPosGiftCardsDTO;
	items: IPosItemDTO[];
	labels: IPosLabelsDTO;
	payment: IPosPaymentDTO;
	quote: IPosQuoteDTO;
	staffMemberId: number;
	staffOptions: IScreenOptionDTO[];
	title: string;
}
export interface IPosCategoryDTO
{
	count: number;
	key: string;
	label: string;
}
export interface IPosItemDTO
{
	available: boolean;
	categoryKey: string;
	description: string;
	giftCardTypeId: number;
	imageUrl: string;
	inventoryItemId: number;
	key: string;
	name: string;
	priceText: string;
	stockLevel: string;
	stockText: string;
}
export interface IPosPaymentDTO
{
	accounts: IScreenOptionDTO[];
	chooseAccount: boolean;
	moneyAccountId?: number;
	status: string;
	statuses: ICalendarOptionDTO[];
}
export interface IPosGiftCardsDTO
{
	enabled: boolean;
	help: string;
	noneFound: string;
	searchPrompt: string;
	title: string;
}
export interface IPosLabelsDTO
{
	addItemsToStart: string;
	back: string;
	cart: string;
	cartEmpty: string;
	create: string;
	customer: string;
	discard: string;
	discardMessage: string;
	discardTitle: string;
	dropIn: string;
	financialDetails: string;
	moneyAccount: string;
	newCustomer: string;
	next: string;
	orderDetails: string;
	partialAmount: string;
	paymentStatus: string;
	remove: string;
	searchCustomers: string;
	searchProducts: string;
	staff: string;
	stepCustomer: string;
	stepItems: string;
	stepPayment: string;
	total: string;
}
export interface IPosFormRequestDTO
{
	customerId: number;
	giftCardCodes: string[];
	lines: IPosLineRequestDTO[];
	moneyAccountId?: number;
	partialPaymentAmount?: number;
	paymentStatus: string;
	staffMemberId: number;
}
export interface IPosLineRequestDTO
{
	inventoryItemId: number;
	quantity: number;
}
export interface IPosQuoteDTO
{
	customerStepDone: boolean;
	giftCards: IPosGiftCardLineDTO[];
	invalid: string;
	itemCount: number;
	itemCountText: string;
	itemsStepDone: boolean;
	lines: IPosLineDTO[];
	paidOnly: boolean;
	partialHint: string;
	summary: IDashboardFieldDTO[];
	totalText: string;
}
export interface IPosLineDTO
{
	canIncrease: boolean;
	imageUrl: string;
	inventoryItemId: number;
	name: string;
	priceText: string;
	quantity: number;
	totalText: string;
}
export interface IPosGiftCardLineDTO
{
	amountText: string;
	code: string;
	name: string;
}
export interface IPosGiftCardSearchDTO
{
	cards: IPosGiftCardOptionDTO[];
	message: string;
}
export interface IPosGiftCardOptionDTO
{
	code: string;
	statusText: string;
	subtitle: string;
}
export interface IPosFormSavedDTO
{
	number: number;
	orderId: number;
}
export interface IPushSettingsScreenDTO
{
	emptyMessage: string;
	permission: IPushPermissionTextsDTO;
	sections: IPushSettingsSectionDTO[];
	test: IPushTestRowDTO;
	title: string;
}
export interface IPushSettingsSectionDTO
{
	footer: string;
	key: string;
	title: string;
	toggles: IPushSettingToggleDTO[];
}
export interface IPushSettingToggleDTO
{
	enabled: boolean;
	key: string;
	subtitle: string;
	title: string;
}
export interface IPushPermissionTextsDTO
{
	deniedMessage: string;
	deniedTitle: string;
	openSettings: string;
}
export interface IPushTestRowDTO
{
	enabled: boolean;
	footer: string;
	title: string;
}
export interface IPushSettingUpdateDTO
{
	enabled: boolean;
}
export interface IPushDeviceRegistrationDTO
{
	appVersion: string;
	environment: string;
	installationId: string;
	locale: string;
	token: string;
}
export interface IPushTestResultDTO
{
	message: string;
	sent: boolean;
}
export interface IStaffDailyEarningsDTO
{
	earnings: number[];
	staffId: number;
	staffName: string;
}
export interface IStaffStatisticsAppointmentDTO
{
	appointments: number[];
	staffId: number;
	staffName: string;
}
export interface IStaffMonthlyEarningsDTO
{
	earnings: number[];
	staffId: number;
	staffName: string;
}
export interface IStatisticsScreenDTO
{
	appointmentsTable: IScreenTableDTO;
	chart: IScreenChartDTO;
	earningsTable: IScreenTableDTO;
	hasMultipleStaff: boolean;
	kpis: IScreenKpiDTO[];
	month: number;
	monthOptions: IScreenOptionDTO[];
	servicesTable: IScreenTableDTO;
	staffAppointmentsTable: IScreenTableDTO;
	staffEarningsTable: IScreenTableDTO;
	staffMemberId: number;
	staffOptions: IScreenOptionDTO[];
	title: string;
	year: number;
	yearOptions: IScreenOptionDTO[];
}
export interface IScreenOptionDTO
{
	label: string;
	value: number;
}
export interface IScreenKpiDTO
{
	key: string;
	label: string;
	text: string;
	value: number;
}
export interface IScreenChartDTO
{
	kind: string;
	labels: string[];
	series: IScreenSeriesDTO[];
}
export interface IScreenSeriesDTO
{
	key: string;
	label: string;
	texts: string[];
	values: number[];
}
export interface IScreenTableDTO
{
	columns: IScreenColumnDTO[];
	rows: IScreenRowDTO[];
}
export interface IScreenColumnDTO
{
	key: string;
	label: string;
}
export interface IScreenRowDTO
{
	cells: IScreenCellDTO[];
}
export interface IScreenCellDTO
{
	text: string;
	value?: number;
}
export interface IUpdateInventoryItemDTO
{
	categoryId?: number;
	commissionPercentage: number;
	costPrice: number;
	description: string;
	eligibleForCommission: boolean;
	minimumStockThreshold: number;
	name: string;
	reorderLevel: number;
	salePrice: number;
	sku: string;
}
export interface IYearlyEarningsComparisonDTO
{
	current: number[];
	previous: number[];
}
export interface IYearlyProfitDTO
{
	monthlyEarnings: number[];
	monthlyNetProfit: number[];
	monthlyOneTimeExpenses: number[];
	monthlyRecurringExpenses: number[];
	monthlyTotalExpenses: number[];
	totalEarnings: number;
	totalExpensesSum: number;
	totalNetProfit: number;
	totalOneTimeExpenses: number;
	totalRecurringExpenses: number;
}
export interface IInventoryItemDTO
{
	category: IInventoryItemCategoryDTO;
	categoryId?: number;
	commissionPercentage: number;
	costPrice: number;
	createdAt: any;
	currentStock: number;
	description: string;
	eligibleForCommission: boolean;
	id: number;
	imageUrl: string;
	isStockItem: boolean;
	minimumStockThreshold: number;
	name: string;
	reorderLevel: number;
	salePrice: number;
	sku: string;
	updatedAt?: any;
}
export interface IAddStockDTO
{
	batchNumber: string;
	inventoryItemId: number;
	moneyAccountId: number;
	purchaseDate: any;
	purchasePrice: number;
	quantity: number;
	totalPurchasePrice: number;
	useTotalPrice: boolean;
}
export interface IInventoryItemCategoryDTO
{
	createdAt: any;
	description: string;
	id: number;
	isActive: boolean;
	name: string;
	updatedAt?: any;
	userId: string;
}
export interface IPostInventoryItemCategoryDTO
{
	description: string;
	name: string;
}
export interface IUpdateInventoryItemCategoryDTO
{
	description: string;
	isActive: boolean;
	name: string;
}
export interface IDetailedBalanceDTO
{
	paid: number;
	remaining: number;
	total: number;
}
export interface IExpenseDTO
{
	amount: number;
	category: ExpenseCategory;
	createdAt: any;
	endDate?: any;
	id: number;
	isActive?: boolean;
	moneyAccount: IMoneyAccountDTO;
	moneyAccountId?: number;
	name: string;
	notes: string;
	purchaseDate?: any;
	receipt: string;
	recurrenceInterval?: RecurrenceInterval;
	sourceId: number;
	startDate?: any;
	updatedAt?: any;
}
export interface IRecurringExpenseDTO
{
	amount: number;
	category: ExpenseCategory;
	createdAt: any;
	endDate?: any;
	id: number;
	isActasdasdive: boolean;
	isActive: boolean;
	moneyAccountId?: number;
	name: string;
	recurrenceInterval: RecurrenceInterval;
	sourceId: number;
	startDate: any;
	updatedAt?: any;
}
export interface IPostInventoryItemDTO
{
	categoryId?: number;
	commissionPercentage: number;
	costPrice: number;
	currentStock: number;
	description: string;
	eligibleForCommission: boolean;
	imageUrl: string;
	isStockItem: boolean;
	minimumStockThreshold: number;
	name: string;
	reorderLevel: number;
	salePrice: number;
	sku: string;
}
export interface IPostOrderDTO
{
	appointmentId?: number;
	customerId: number;
	giftCardCodes: string[];
	orderDate: any;
	paymentMethod: PaymentMethod;
	salesItems: IPostSalesItemDTO[];
	staffId?: number;
}
export interface IPostSalesItemDTO
{
	inventoryItemId: number;
	quantity: number;
}
export interface IPostLedgerPaymentDTO
{
	allocations: IPostPaymentAllocationDTO[];
	amount: number;
	customerId: number;
	paymentMethod: PaymentMethod;
	reference: string;
}
export interface IPostPaymentAllocationDTO
{
	amount: number;
	ledgerEntryId: number;
}
export interface IOneTimeExpenseDTO
{
	amount: number;
	amountxxxx: number;
	category: ExpenseCategory;
	createdAt: any;
	id: number;
	moneyAccountId?: number;
	notes: string;
	purchaseDate: any;
	receipt: string;
	sourceId: number;
	updatedAt?: any;
}
export interface IPostRecurringExpenseDTO
{
	amount: number;
	category: ExpenseCategory;
	endDate?: any;
	moneyAccountId?: number;
	name: string;
	recurrenceInterval: RecurrenceInterval;
	sourceId: number;
	startDate: any;
}
export interface IPostOneTimeExpenseDTO
{
	amount: number;
	category: ExpenseCategory;
	moneyAccountId?: number;
	name: string;
	notes: string;
	purchaseDate: any;
	receipt: string;
	sourceId: number;
}
export interface IFirebaseUserRecordDTO
{
	disabled: boolean;
	displayName: string;
	email: string;
	emailVerified: boolean;
	phoneNumber: string;
	photoUrl: string;
	tenantId: string;
	uid: string;
	userMetaData: any;
}
export abstract class IAdminController
{
	static GetTokenRoute: IRouteDefinition = { url: "admin/token/{uid}", method: HttpVerb.Get, queryType: "" };
	static GetUsersRoute: IRouteDefinition = { url: "admin/users", method: HttpVerb.Get, queryType: "" };
	public abstract getToken(uid: string): Promise<string>;
	public abstract getUsers(): Promise<IFirebaseUserRecordDTO[]>;
}
export abstract class IAccountRoleController
{
	static CreateRoleRoute: IRouteDefinition = { url: "AccountRole/current", method: HttpVerb.Post, queryType: "" };
	static DeleteRoleRoute: IRouteDefinition = { url: "AccountRole/current/{id}", method: HttpVerb.Delete, queryType: "" };
	static GetRoleRoute: IRouteDefinition = { url: "AccountRole/current/{id}", method: HttpVerb.Get, queryType: "" };
	static GetRolesRoute: IRouteDefinition = { url: "AccountRole/current", method: HttpVerb.Get, queryType: "" };
	static UpdateRoleRoute: IRouteDefinition = { url: "AccountRole/current/{id}", method: HttpVerb.Put, queryType: "" };
	public abstract getRoles(): Promise<IAccountRoleDTO[]>;
	public abstract getRole(id: number): Promise<IAccountRoleDTO>;
	public abstract createRole(roleDto: IAccountRoleDTO): Promise<IAccountRoleDTO>;
	public abstract updateRole(id: number, roleDto: IAccountRoleDTO): Promise<any>;
	public abstract deleteRole(id: number): Promise<any>;
}
export abstract class IAppointmentFormController
{
	static GetFlowRoute: IRouteDefinition = { url: "Appointment/current/form/flow", method: HttpVerb.Get, queryType: "" };
	static GetFormRoute: IRouteDefinition = { url: "Appointment/current/form/", method: HttpVerb.Get, queryType: "" };
	static NewCustomerRoute: IRouteDefinition = { url: "Appointment/current/form/new-customer", method: HttpVerb.Get, queryType: "" };
	static QuoteRoute: IRouteDefinition = { url: "Appointment/current/form/quote", method: HttpVerb.Post, queryType: "" };
	static SaveRoute: IRouteDefinition = { url: "Appointment/current/form/save", method: HttpVerb.Post, queryType: "" };
	static SearchCustomersRoute: IRouteDefinition = { url: "Appointment/current/form/customers", method: HttpVerb.Get, queryType: "" };
	static SearchGiftCardsRoute: IRouteDefinition = { url: "Appointment/current/form/gift-cards", method: HttpVerb.Post, queryType: "" };
	public abstract getForm(id: number, date?: string, startMinute?: number, staffMemberId?: number): Promise<IAppointmentFormDTO>;
	public abstract getFlow(date?: string, startMinute?: number, staffMemberId?: number, customerId?: number): Promise<IAppointmentBookingFlowDTO>;
	public abstract searchCustomers(search?: string): Promise<IScreenOptionDTO[]>;
	public abstract newCustomer(search?: string): Promise<ICustomerFormValuesDTO>;
	public abstract searchGiftCards(request: IAppointmentFormRequestDTO, search?: string): Promise<IAppointmentGiftCardSearchDTO>;
	public abstract quote(request: IAppointmentFormRequestDTO): Promise<IAppointmentFormQuoteDTO>;
	public abstract save(request: IAppointmentFormRequestDTO): Promise<IAppointmentFormSavedDTO>;
}
export abstract class ICalendarController
{
	static GetAppointmentRoute: IRouteDefinition = { url: "Calendar/current/appointments/{id}", method: HttpVerb.Get, queryType: "" };
	static GetScreenRoute: IRouteDefinition = { url: "Calendar/current/screen", method: HttpVerb.Get, queryType: "" };
	static MoveAppointmentRoute: IRouteDefinition = { url: "Calendar/current/appointments/{id}/move", method: HttpVerb.Post, queryType: "" };
	public abstract getAppointment(id: number): Promise<ICalendarAppointmentDTO>;
	public abstract moveAppointment(id: number, move: IMoveAppointmentDTO): Promise<any>;
	public abstract getScreen(view: string, date: string | undefined, staffMemberId: number): Promise<ICalendarScreenDTO>;
}
export abstract class ICommissionController
{
	static CreateCommissionRoute: IRouteDefinition = { url: "Commission/create", method: HttpVerb.Post, queryType: "" };
	static GetCommissionsForDateRoute: IRouteDefinition = { url: "Commission/date/{year}/{month}/{day}", method: HttpVerb.Get, queryType: "" };
	public abstract createCommission(createCommissionDTO: ICreateCommissionDTO): Promise<ICommissionDTO>;
	public abstract getCommissionsForDate(year: number, month: number, day: number): Promise<ICommissionDTO[]>;
}
export abstract class ICustomerScreenController
{
	static AddLedgerEntryRoute: IRouteDefinition = { url: "Customer/current/{customerId:int}/ledger", method: HttpVerb.Post, queryType: "" };
	static CreateFromFormRoute: IRouteDefinition = { url: "Customer/current/form", method: HttpVerb.Post, queryType: "" };
	static DeleteSelectedRoute: IRouteDefinition = { url: "Customer/current/delete", method: HttpVerb.Post, queryType: "" };
	static GetFormRoute: IRouteDefinition = { url: "Customer/current/form", method: HttpVerb.Get, queryType: "" };
	static GetLedgerScreenRoute: IRouteDefinition = { url: "Customer/current/{customerId:int}/ledger/screen", method: HttpVerb.Get, queryType: "" };
	static GetLedgerSourceRoute: IRouteDefinition = { url: "Customer/current/{customerId:int}/ledger/{entryId:int}/source", method: HttpVerb.Get, queryType: "" };
	static GetListScreenRoute: IRouteDefinition = { url: "Customer/current/list/screen", method: HttpVerb.Get, queryType: "" };
	static GetPageScreenRoute: IRouteDefinition = { url: "Customer/current/{customerId:int}/screen", method: HttpVerb.Get, queryType: "" };
	static GetStatisticsScreenRoute: IRouteDefinition = { url: "Customer/current/{customerId:int}/statistics/screen", method: HttpVerb.Get, queryType: "" };
	static SaveNotesRoute: IRouteDefinition = { url: "Customer/current/{customerId:int}/notes", method: HttpVerb.Patch, queryType: "" };
	static UpdateFromFormRoute: IRouteDefinition = { url: "Customer/current/{customerId:int}/form", method: HttpVerb.Put, queryType: "" };
	private forbidden(user: any) : any
	{
		return null;
	}
	private notFoundError(user: any) : IScreenValidationErrorDTO
	{
		return null;
	}
	public abstract getListScreen(page: number, pageSize: number, search: string | undefined, sort: string, desc: boolean): Promise<ICustomerListScreenDTO>;
	public abstract deleteSelected(body: ICustomerDeleteRequestDTO): Promise<ICustomerDeleteResultDTO>;
	public abstract getPageScreen(customerId: number, opened: boolean): Promise<ICustomerPageScreenDTO>;
	public abstract getLedgerScreen(customerId: number, search: string | undefined, sort: string, desc: boolean): Promise<ICustomerLedgerScreenDTO>;
	public abstract getLedgerSource(customerId: number, entryId: number): Promise<ICustomerLedgerSourceDTO>;
	public abstract getStatisticsScreen(customerId: number): Promise<ICustomerStatisticsScreenDTO>;
	public abstract getForm(id: number): Promise<ICustomerFormDTO>;
	public abstract createFromForm(values: ICustomerFormValuesDTO): Promise<ICustomerSavedDTO>;
	public abstract updateFromForm(customerId: number, values: ICustomerFormValuesDTO): Promise<ICustomerSavedDTO>;
	public abstract saveNotes(customerId: number, body: ICustomerNotesUpdateDTO): Promise<ICustomerNotesSavedDTO>;
	public abstract addLedgerEntry(customerId: number, body: ICustomerLedgerEntryCreateDTO): Promise<ICustomerLedgerScreenDTO>;
}
export abstract class IGoogleCalendarController
{
	public abstract syncAppWithCalendar(): Promise<string>;
	public abstract revokeToken(staffMemberID: number): Promise<any>;
	public abstract authenticateByCode(code: any): Promise<any>;
}
export abstract class IInventoryItemCategoryController
{
	static CreateCategoryRoute: IRouteDefinition = { url: "InventoryItemCategory/current", method: HttpVerb.Post, queryType: "" };
	static DeleteCategoryRoute: IRouteDefinition = { url: "InventoryItemCategory/current/{id}", method: HttpVerb.Delete, queryType: "" };
	static GetCategoriesRoute: IRouteDefinition = { url: "InventoryItemCategory/current", method: HttpVerb.Get, queryType: "" };
	static GetCategoryRoute: IRouteDefinition = { url: "InventoryItemCategory/current/{id}", method: HttpVerb.Get, queryType: "" };
	static UpdateCategoryRoute: IRouteDefinition = { url: "InventoryItemCategory/current/{id}", method: HttpVerb.Put, queryType: "" };
	public abstract getCategories(): Promise<IInventoryItemCategoryDTO[]>;
	public abstract getCategory(id: number): Promise<IInventoryItemCategoryDTO>;
	public abstract createCategory(categoryDto: IPostInventoryItemCategoryDTO): Promise<IInventoryItemCategoryDTO>;
	public abstract updateCategory(id: number, categoryDto: IUpdateInventoryItemCategoryDTO): Promise<any>;
	public abstract deleteCategory(id: number): Promise<any>;
}
export abstract class IInventoryItemController
{
	static AddStockRoute: IRouteDefinition = { url: "InventoryItem/current/stock", method: HttpVerb.Post, queryType: "" };
	static CreateRoute: IRouteDefinition = { url: "InventoryItem/current", method: HttpVerb.Post, queryType: "" };
	static DeleteRoute: IRouteDefinition = { url: "InventoryItem/current/{id}", method: HttpVerb.Delete, queryType: "" };
	static GetAllRoute: IRouteDefinition = { url: "InventoryItem/current", method: HttpVerb.Get, queryType: "" };
	static GetByIdRoute: IRouteDefinition = { url: "InventoryItem/current/{id}", method: HttpVerb.Get, queryType: "" };
	static GetLowStockItemsRoute: IRouteDefinition = { url: "InventoryItem/current/low-stock", method: HttpVerb.Get, queryType: "" };
	static UpdateRoute: IRouteDefinition = { url: "InventoryItem/current/{id}", method: HttpVerb.Put, queryType: "" };
	static UploadItemPictureRoute: IRouteDefinition = { url: "InventoryItem/current/{id}/picture", method: HttpVerb.Put, queryType: "" };
	public abstract getAll(): Promise<IInventoryItemDTO[]>;
	public abstract getById(id: number): Promise<IInventoryItemDTO>;
	public abstract create(dto: IPostInventoryItemDTO): Promise<IInventoryItemDTO>;
	public abstract getLowStockItems(): Promise<IInventoryItemDTO[]>;
	public abstract addStock(dto: IAddStockDTO): Promise<IInventoryItemDTO>;
	public abstract update(id: number, dto: IUpdateInventoryItemDTO): Promise<IInventoryItemDTO>;
	public abstract delete(id: number): Promise<any>;
	public abstract uploadItemPicture(file: any[], id: number): Promise<any>;
}
export abstract class ILedgerEntriesController
{
	static CreateFromAppointmentRoute: IRouteDefinition = { url: "LedgerEntries/current/from-appointment", method: HttpVerb.Post, queryType: "" };
	static CreateFromOrderRoute: IRouteDefinition = { url: "LedgerEntries/current/from-order", method: HttpVerb.Post, queryType: "" };
	static CreateManualRoute: IRouteDefinition = { url: "LedgerEntries/current/manual", method: HttpVerb.Post, queryType: "" };
	static GetAllMoneyAccountEntriesForDateRoute: IRouteDefinition = { url: "LedgerEntries/current/money-accounts/date/{year}/{month}/{day}", method: HttpVerb.Get, queryType: "" };
	static GetCustomerBalanceRoute: IRouteDefinition = { url: "LedgerEntries/current/customer/{customerId}/balance", method: HttpVerb.Get, queryType: "" };
	static GetCustomerEntriesRoute: IRouteDefinition = { url: "LedgerEntries/current/customer/{customerId}", method: HttpVerb.Get, queryType: "" };
	static GetDetailedBalanceRoute: IRouteDefinition = { url: "LedgerEntries/current/detailed-balance", method: HttpVerb.Get, queryType: "IGetDetailedBalanceQuery" };
	static GetEntryWithAppointmentDetailsRoute: IRouteDefinition = { url: "LedgerEntries/current/{id}/details", method: HttpVerb.Get, queryType: "" };
	static GetMoneyAccountEntriesRoute: IRouteDefinition = { url: "LedgerEntries/current/money-account/{moneyAccountId}", method: HttpVerb.Get, queryType: "" };
	static HandleArchivedAppointmentRoute: IRouteDefinition = { url: "LedgerEntries/current/handle-archived/{appointmentId}", method: HttpVerb.Post, queryType: "" };
	public abstract getCustomerEntries(customerId: number): Promise<ILedgerEntryDTO[]>;
	public abstract getMoneyAccountEntries(moneyAccountId: number): Promise<ILedgerEntryDTO[]>;
	public abstract getCustomerBalance(customerId: number): Promise<number>;
	public abstract getEntryWithAppointmentDetails(id: number): Promise<ILedgerEntryDetailsDTO>;
	public abstract createFromAppointment(dto: ICreateAppointmentLedgerEntryDTO): Promise<ILedgerEntryDTO>;
	public abstract createFromOrder(dto: ICreateOrderLedgerEntryDTO): Promise<ILedgerEntryDTO>;
	public abstract handleArchivedAppointment(appointmentId: number): Promise<any>;
	public abstract getDetailedBalance(query: Partial<typeof ILedgerEntriesController.IGetDetailedBalanceQuery>): Promise<IDetailedBalanceDTO>;
	public abstract createManual(dto: ILedgerEntryDTO): Promise<ILedgerEntryDTO>;
	public abstract getAllMoneyAccountEntriesForDate(year: number, month: number, day: number): Promise<ILedgerEntryDTO[]>;
	    public static IGetDetailedBalanceQuery: {
	        customerId: number | null;
	        appointmentId: number | null;
	    };
}
export abstract class IOrderFormController
{
	static GetFormRoute: IRouteDefinition = { url: "Order/current/form/", method: HttpVerb.Get, queryType: "" };
	static QuoteRoute: IRouteDefinition = { url: "Order/current/form/quote", method: HttpVerb.Post, queryType: "" };
	static SaveRoute: IRouteDefinition = { url: "Order/current/form/save", method: HttpVerb.Post, queryType: "" };
	static SearchGiftCardsRoute: IRouteDefinition = { url: "Order/current/form/gift-cards", method: HttpVerb.Post, queryType: "" };
	public abstract getForm(): Promise<IPosFormDTO>;
	public abstract quote(request: IPosFormRequestDTO): Promise<IPosQuoteDTO>;
	public abstract searchGiftCards(request: IPosFormRequestDTO, search?: string, giftCardTypeId?: number): Promise<IPosGiftCardSearchDTO>;
	public abstract save(request: IPosFormRequestDTO): Promise<IPosFormSavedDTO>;
}
export abstract class IPaymentController
{
	public abstract initiatePayment(request: any): Promise<any>;
	public abstract paymentCallback(request: any): Promise<any>;
}
export abstract class IPushController
{
	static GetSettingsRoute: IRouteDefinition = { url: "Push/current/devices/{installationId}/settings", method: HttpVerb.Get, queryType: "" };
	static RegisterDeviceRoute: IRouteDefinition = { url: "Push/current/devices", method: HttpVerb.Post, queryType: "" };
	static SaveSettingRoute: IRouteDefinition = { url: "Push/current/devices/{installationId}/settings/{kind}", method: HttpVerb.Put, queryType: "" };
	static SendTestRoute: IRouteDefinition = { url: "Push/current/devices/{installationId}/test", method: HttpVerb.Post, queryType: "" };
	static UnregisterDeviceRoute: IRouteDefinition = { url: "Push/current/devices/{installationId}", method: HttpVerb.Delete, queryType: "" };
	public abstract getSettings(installationId: string): Promise<IPushSettingsScreenDTO>;
	public abstract saveSetting(installationId: string, kind: string, update: IPushSettingUpdateDTO): Promise<IPushSettingsScreenDTO>;
	public abstract registerDevice(registration: IPushDeviceRegistrationDTO): Promise<any>;
	public abstract unregisterDevice(installationId: string): Promise<any>;
	public abstract sendTest(installationId: string, cancellationToken: any): Promise<IPushTestResultDTO>;
}
export abstract class IStatisticsController
{
	static DownloadDailyFinancialReportRoute: IRouteDefinition = { url: "Statistics/current/daily-report", method: HttpVerb.Get, queryType: "IDownloadDailyFinancialReportQuery" };
	static GetAllYearProfitRoute: IRouteDefinition = { url: "Statistics/current/profit/all-years", method: HttpVerb.Get, queryType: "" };
	static GetAppointmentsSplitByDayAndStaffRoute: IRouteDefinition = { url: "Statistics/current/appointments/splitByDayAndStaff", method: HttpVerb.Get, queryType: "" };
	static GetAppointmentsSplitByDayRoute: IRouteDefinition = { url: "Statistics/current/appointments/splitByDay", method: HttpVerb.Get, queryType: "" };
	static GetAppointmentsSplitByMonthAndStaffRoute: IRouteDefinition = { url: "Statistics/current/appointments/splitByMonthAndStaff", method: HttpVerb.Get, queryType: "" };
	static GetAppointmentsSplitByMonthRoute: IRouteDefinition = { url: "Statistics/current/appointments/splitByMonth", method: HttpVerb.Get, queryType: "" };
	static GetCustomerBookedStatsRoute: IRouteDefinition = { url: "Statistics/current/customerBooked/", method: HttpVerb.Get, queryType: "" };
	static GetMoneyMadeRoute: IRouteDefinition = { url: "Statistics/current/moneyMade", method: HttpVerb.Get, queryType: "" };
	static GetMoneyMadeSplitByDayAndStaffRoute: IRouteDefinition = { url: "Statistics/current/moneyMade/splitByDayAndStaff", method: HttpVerb.Get, queryType: "" };
	static GetMoneyMadeSplitByDayRoute: IRouteDefinition = { url: "Statistics/current/moneyMade/splitByDay", method: HttpVerb.Get, queryType: "" };
	static GetMoneyMadeSplitByMonthAndStaffRoute: IRouteDefinition = { url: "Statistics/current/moneyMade/splitByMonthAndStaff", method: HttpVerb.Get, queryType: "" };
	static GetMonthlyProfitRoute: IRouteDefinition = { url: "Statistics/current/profit/monthly", method: HttpVerb.Get, queryType: "" };
	static GetNumberOfAppointmentsRoute: IRouteDefinition = { url: "Statistics/current/appointments", method: HttpVerb.Get, queryType: "" };
	static GetScreenRoute: IRouteDefinition = { url: "Statistics/current/screen", method: HttpVerb.Get, queryType: "" };
	static GetServicesBookedStatsRoute: IRouteDefinition = { url: "Statistics/current/servicesBooked/", method: HttpVerb.Get, queryType: "" };
	static GetYearlyProfitRoute: IRouteDefinition = { url: "Statistics/current/profit/yearly", method: HttpVerb.Get, queryType: "" };
	static NewCustomersRoute: IRouteDefinition = { url: "Statistics/current/newCustomers/", method: HttpVerb.Get, queryType: "" };
	public abstract getScreen(year: number, month: number, staffMemberId: number): Promise<IStatisticsScreenDTO>;
	public abstract getNumberOfAppointments(day: number, month: number, year: number, staffMemberId: number): Promise<number>;
	public abstract getMoneyMade(day: number, month: number, year: number, staffMemberId: number): Promise<number>;
	public abstract getMoneyMadeSplitByMonth(year: number, staffMemberId: number): Promise<IYearlyEarningsComparisonDTO>;
	public abstract getMoneyMadeSplitByDay(year: number, month: number, staffMemberId: number): Promise<IDailyProfitDTO>;
	public abstract newCustomers(year: number): Promise<INewCustomerStatsDTO>;
	public abstract getCustomerBookedStats(year: number, month: number): Promise<ICustomerStatDTO[]>;
	public abstract getServicesBookedStats(year: number, month: number, staffMemberId?: number): Promise<IServiceStatDTO[]>;
	public abstract getMoneyMadeSplitByMonthAndStaff(year: number): Promise<IStaffMonthlyEarningsDTO[]>;
	public abstract getMoneyMadeSplitByDayAndStaff(year: number, month: number): Promise<IStaffDailyEarningsDTO[]>;
	public abstract getAppointmentsSplitByMonthAndStaff(year: number): Promise<IStaffStatisticsAppointmentDTO[]>;
	public abstract getAppointmentsSplitByDayAndStaff(year: number, month: number): Promise<IStaffStatisticsAppointmentDTO[]>;
	public abstract getAppointmentsSplitByMonth(year: number, staffMemberId: number): Promise<IYearlyEarningsComparisonDTO>;
	public abstract getAppointmentsSplitByDay(year: number, month: number, staffMemberId: number): Promise<number[]>;
	public abstract getMonthlyProfit(year: number, month: number, staffMemberId: number): Promise<IMonthlyProfitDTO>;
	public abstract getYearlyProfit(year: number, staffMemberId: number): Promise<IYearlyProfitDTO>;
	public abstract getAllYearProfit(staffMemberId: number): Promise<{ [key:number]: IYearlyProfitDTO }>;
	public abstract downloadDailyFinancialReport(query: Partial<typeof IStatisticsController.IDownloadDailyFinancialReportQuery>): Promise<Blob>;
	    public static IDownloadDailyFinancialReportQuery: {
	        year: number | null;
	        month: number | null;
	        day: number | null;
	    };
}
export interface IStaffMemberAnonymousRequestDTO
{
	serviceBookings: IServiceBookingPostDTO[];
}
export interface IStaffMemberStatisticsDTO
{
	payments: IPaymentStatDTO[];
	products: IProductStatDTO[];
	services: IServiceStatStaffMemberDTO[];
}
export interface IServiceStatStaffMemberDTO
{
	commission: number;
	count: number;
	date?: any;
	name: string;
	revenue: number;
}
export interface IProductStatDTO
{
	commission: number;
	date?: any;
	name: string;
	quantity: number;
	revenue: number;
}
export interface IPaymentStatDTO
{
	amount: number;
	date?: any;
	status: string;
	type: ExpenseCategory;
}
export interface ICommissionDataDTO
{
	dailyCommissions: IDailyCommissionDTO[];
	staffMemberId: number;
	staffMemberName: string;
}
export interface IDailyCommissionDTO
{
	date: any;
	paidCommission: number;
	totalCommission: number;
}
export abstract class IAuditLogController
{
	static GetCurrentAuditLogsRoute: IRouteDefinition = { url: "AuditLog/current", method: HttpVerb.Get, queryType: "" };
	static PostAuditAnonymousRoute: IRouteDefinition = { url: "AuditLog/asAnonymous/{userId}", method: HttpVerb.Post, queryType: "" };
	static PostAuditRoute: IRouteDefinition = { url: "AuditLog/current", method: HttpVerb.Post, queryType: "" };
	public abstract getCurrentAuditLogs(ignoreFlag: number): Promise<IAuditLogDTO[]>;
	public abstract postAuditAnonymous(userId: string, dto: IPostAuditLogDTO): Promise<any>;
	public abstract postAudit(dto: IPostAuditLogDTO): Promise<any>;
}
export abstract class ICompanyController
{
	static CreateAndJoinCompanyRoute: IRouteDefinition = { url: "Company/CreateAndJoin/current", method: HttpVerb.Post, queryType: "" };
	static DeleteCompanyRoute: IRouteDefinition = { url: "Company/current", method: HttpVerb.Delete, queryType: "" };
	static GetConnectionsRoute: IRouteDefinition = { url: "Company/connect", method: HttpVerb.Get, queryType: "" };
	static GetCurrentCompanyRoute: IRouteDefinition = { url: "Company/current", method: HttpVerb.Get, queryType: "" };
	static JoinCompanyRoute: IRouteDefinition = { url: "Company/join/current", method: HttpVerb.Put, queryType: "" };
	public abstract getConnections(id: string): Promise<IBookingPageDTO[]>;
	public abstract getCompanies(): Promise<ICompanyDTO[]>;
	public abstract getCurrentCompany(): Promise<ICompanyDTO>;
	public abstract getCompany(id: number): Promise<ICompanyDTO>;
	public abstract postCompany(companyDTO: ICompanyDTO): Promise<void>;
	public abstract joinCompany(companyId: number): Promise<void>;
	public abstract createAndJoinCompany(companyDTO: ICompanyDTO): Promise<void>;
	public abstract deleteCompany(): Promise<void>;
}
export abstract class ICustomerAccountController
{
	static GetCustomerAccountByPhoneNumberAndPasswordRoute: IRouteDefinition = { url: "CustomerAccount/byPhoneAndPassword", method: HttpVerb.Post, queryType: "" };
	static GetCustomerAccountByPhoneNumberRoute: IRouteDefinition = { url: "CustomerAccount/byPhone", method: HttpVerb.Post, queryType: "" };
	static ResetPasswordByCodeRoute: IRouteDefinition = { url: "CustomerAccount/resetPasswordByCode", method: HttpVerb.Post, queryType: "" };
	static ResetPasswordRoute: IRouteDefinition = { url: "CustomerAccount/resetPassword", method: HttpVerb.Post, queryType: "" };
	private static passwordMatches(storedPassword: string, candidate: string, key: string) : boolean
	{
		return null;
	}
	public abstract resetPasswordByCode(resetInfo: IResetPasswordByCode): Promise<any>;
	public abstract putCustomerAccount(customerAccount: IEditCustomerAccountDTO): Promise<any>;
	public abstract resetPassword(req: ICustomerAccountAnonymousRequest): Promise<any>;
	public abstract getCustomerAccountByPhoneNumber(req: ICustomerAccountAnonymousRequest): Promise<void>;
	public abstract getCustomerAccountByPhoneNumberAndPassword(login: ICustomerAccountRequest): Promise<ICustomerAccountDTO>;
	public abstract createCustomerAccount(customerAccount: IPostCustomerAccountDTO): Promise<any>;
}
export abstract class IDashboardController
{
	static AuditNewAppointmentRoute: IRouteDefinition = { url: "Dashboard/current/new-appointment", method: HttpVerb.Post, queryType: "" };
	static AuditReadRoute: IRouteDefinition = { url: "Dashboard/current/appointments/{id}/read", method: HttpVerb.Post, queryType: "" };
	static GetScreenRoute: IRouteDefinition = { url: "Dashboard/current/screen", method: HttpVerb.Get, queryType: "" };
	static MarkUpdateReadRoute: IRouteDefinition = { url: "Dashboard/current/updates/{id}/read", method: HttpVerb.Post, queryType: "" };
	public abstract getScreen(): Promise<IDashboardScreenDTO>;
	public abstract auditRead(id: number, body: IDashboardReadDTO): Promise<any>;
	public abstract auditNewAppointment(): Promise<any>;
	public abstract markUpdateRead(id: number): Promise<any>;
}
export abstract class IDebugLogController
{
	static GetEventsRoute: IRouteDefinition = { url: "DebugLog/current", method: HttpVerb.Get, queryType: "" };
	public abstract getEvents(): Promise<IDebugLogDTO[]>;
}
export abstract class IEmailListController
{
	static GetRoute: IRouteDefinition = { url: "EmailList/current", method: HttpVerb.Get, queryType: "" };
	public abstract get(): Promise<IEmailListEntryDTO[]>;
}
export interface IPaginatedEventsResponseDTO
{
	items: IEventDTO[];
	itemsPerPage: number;
	page: number;
	sortBy: string;
	sortDesc: boolean;
	total: number;
}
export abstract class IEventsController
{
	static GetEventsRoute: IRouteDefinition = { url: "Event/current", method: HttpVerb.Get, queryType: "IGetEventsQuery" };
	static GetUnSeenEventsRoute: IRouteDefinition = { url: "Event/current/unSeen", method: HttpVerb.Get, queryType: "" };
	static MarkAsReadRoute: IRouteDefinition = { url: "Event/current/markAsRead", method: HttpVerb.Post, queryType: "" };
	public abstract getUnSeenEvents(): Promise<number>;
	public abstract markAsRead(): Promise<IEventDTO[]>;
	public abstract getEvents(query: Partial<typeof IEventsController.IGetEventsQuery>): Promise<IPaginatedEventsResponseDTO>;
	    public static IGetEventsQuery: {
	        page: number | null;
	        itemsPerPage: number | null;
	        sortBy: string | null;
	        desc: string | null;
	    };
}
export abstract class IFirebaseUserController
{
	static DeleteFirebaseUserRoute: IRouteDefinition = { url: "FirebaseUser/current/{firebaseUserId}", method: HttpVerb.Delete, queryType: "" };
	static GetAllRoute: IRouteDefinition = { url: "FirebaseUser/current/all", method: HttpVerb.Get, queryType: "" };
	static GetCurrentFirebaseUserRoute: IRouteDefinition = { url: "FirebaseUser/current", method: HttpVerb.Get, queryType: "" };
	static PatchFirebaseUserRoute: IRouteDefinition = { url: "FirebaseUser/current", method: HttpVerb.Patch, queryType: "" };
	static PostFirebaseAccountAsyncRoute: IRouteDefinition = { url: "FirebaseUser/current", method: HttpVerb.Post, queryType: "" };
	public abstract getCurrentFirebaseUser(): Promise<IFirebaseUserDTO>;
	public abstract getAll(): Promise<IFirebaseUserDTO[]>;
	public abstract postFirebaseAccountAsync(staffMember: any): Promise<any>;
	public abstract patchFirebaseUser(patchDoc: any, firebaseUserId: string): Promise<any>;
	public abstract deleteFirebaseUser(firebaseUserId: string): Promise<any>;
}
export abstract class IGiftCardsController
{
	static ExportBatchPdfRoute: IRouteDefinition = { url: "GiftCards/export-pdf", method: HttpVerb.Get, queryType: "IExportBatchPdfQuery" };
	static GetBatchesRoute: IRouteDefinition = { url: "GiftCards/batches", method: HttpVerb.Get, queryType: "IGetBatchesQuery" };
	static GetGiftCardsRoute: IRouteDefinition = { url: "GiftCards/", method: HttpVerb.Get, queryType: "IGetGiftCardsQuery" };
	public abstract getTypes(): Promise<IGiftCardTypeDTO[]>;
	public abstract upsertType(dto: IUpsertGiftCardTypeDTO): Promise<IGiftCardTypeDTO>;
	public abstract generate(dto: IGenerateGiftCardBatchDTO): Promise<IGiftCardBatchDTO>;
	public abstract getBatches(query: Partial<typeof IGiftCardsController.IGetBatchesQuery>): Promise<IGiftCardBatchDTO[]>;
	public abstract getGiftCards(query: Partial<typeof IGiftCardsController.IGetGiftCardsQuery>): Promise<IGiftCardDTO[]>;
	public abstract exportBatchPdf(query: Partial<typeof IGiftCardsController.IExportBatchPdfQuery>): Promise<any>;
	public abstract sell(dto: ISellGiftCardsRequestDTO): Promise<IGiftCardDTO[]>;
	public abstract redeem(dto: IRedeemGiftCardRequestDTO): Promise<IGiftCardDTO>;
	public abstract getByCode(code: string): Promise<IGiftCardDTO>;
	    public static IGetBatchesQuery: {
	        includeCards: string;
	    };
	    public static IGetGiftCardsQuery: {
	        status: GiftCardStatus | null;
	    };
	    public static IExportBatchPdfQuery: {
	        batchId: number | null;
	    };
}
export abstract class IInsuranceController
{
	static DeleteRoute: IRouteDefinition = { url: "Insurance/current", method: HttpVerb.Delete, queryType: "" };
	static GetByIdRoute: IRouteDefinition = { url: "Insurance/current/{id}", method: HttpVerb.Get, queryType: "" };
	static GetRoute: IRouteDefinition = { url: "Insurance/current", method: HttpVerb.Get, queryType: "" };
	static PostRoute: IRouteDefinition = { url: "Insurance/current", method: HttpVerb.Post, queryType: "" };
	static PutRoute: IRouteDefinition = { url: "Insurance/current", method: HttpVerb.Put, queryType: "" };
	public abstract put(insurance: IInsuranceDTO): Promise<IInsuranceDTO>;
	public abstract post(insurance: IInsuranceDTO): Promise<void>;
	public abstract get(): Promise<IInsuranceDTO[]>;
	public abstract delete(id: number): Promise<void>;
	public abstract getById(id: number): Promise<IInsuranceDTO>;
}
export abstract class IInvoiceController
{
	static ChangeStatusRoute: IRouteDefinition = { url: "Invoice/status/current", method: HttpVerb.Put, queryType: "" };
	static GetInvoiceNumberRoute: IRouteDefinition = { url: "Invoice/invoiceNumber/current", method: HttpVerb.Get, queryType: "" };
	static GetInvoicesForAppointmentRoute: IRouteDefinition = { url: "Invoice/forAppointment/current", method: HttpVerb.Get, queryType: "" };
	static GetInvoicesForCustomerRoute: IRouteDefinition = { url: "Invoice/forCustomer/current", method: HttpVerb.Get, queryType: "" };
	static GetPdfRoute: IRouteDefinition = { url: "Invoice/pdf/current", method: HttpVerb.Get, queryType: "" };
	static GetRoute: IRouteDefinition = { url: "Invoice/current", method: HttpVerb.Get, queryType: "" };
	static PostRoute: IRouteDefinition = { url: "Invoice/current", method: HttpVerb.Post, queryType: "" };
	static SendInvoiceRoute: IRouteDefinition = { url: "Invoice/send/current", method: HttpVerb.Post, queryType: "" };
	public abstract get(): Promise<IInvoiceDTO[]>;
	public abstract changeStatus(invoiceId: number, status: string): Promise<void>;
	public abstract sendInvoice(dto: ISendInvoiceDTO): Promise<void>;
	public abstract post(dto: IPostInvoiceDTO): Promise<IInvoiceDTO>;
	public abstract getInvoiceNumber(): Promise<number>;
	public abstract getInvoicesForCustomer(id: number): Promise<IInvoiceDTO[]>;
	public abstract getInvoicesForAppointment(appointmentId: number): Promise<IInvoiceDTO[]>;
	public abstract getPdf(invoiceId: number): Promise<any>;
}
export abstract class IStaffMemberController
{
	static DeleteStaffMemberRoute: IRouteDefinition = { url: "StaffMember/current/{staffMemberId}", method: HttpVerb.Delete, queryType: "" };
	static EditServiceStateOnStaffMemberRoute: IRouteDefinition = { url: "StaffMember/current/service/{staffMemberId}/{serviceId}/{enabled}", method: HttpVerb.Put, queryType: "" };
	static GetStaffMemberCommissionsRoute: IRouteDefinition = { url: "StaffMember/current/commissions/{year}/{month}", method: HttpVerb.Get, queryType: "" };
	static GetStaffMemberCountRoute: IRouteDefinition = { url: "StaffMember/count/{adminId}", method: HttpVerb.Get, queryType: "" };
	static GetStaffMembersAsAnonymousRoute: IRouteDefinition = { url: "StaffMember/asAnonymous/{adminId}", method: HttpVerb.Post, queryType: "" };
	static GetStaffMembersRoute: IRouteDefinition = { url: "StaffMember/current", method: HttpVerb.Get, queryType: "" };
	static GetStaffMemberStatisticsRoute: IRouteDefinition = { url: "StaffMember/current/statistics/{staffMemberId}/{year}/{month}/{day}", method: HttpVerb.Get, queryType: "" };
	static PatchStaffMemberRoute: IRouteDefinition = { url: "StaffMember/current/{staffMemberId}", method: HttpVerb.Patch, queryType: "" };
	static PostStaffMemberRoute: IRouteDefinition = { url: "StaffMember/current", method: HttpVerb.Post, queryType: "" };
	static StaffMemberHasOAuthRoute: IRouteDefinition = { url: "StaffMember/current/hasOAuth/{staffMemberID}", method: HttpVerb.Get, queryType: "" };
	static UploadStaffMemberPictureRoute: IRouteDefinition = { url: "StaffMember/current/picture/{staffMemberId}", method: HttpVerb.Put, queryType: "" };
	public abstract staffMemberHasOAuth(staffMemberID: number): Promise<boolean>;
	public abstract getStaffMembers(): Promise<IStaffMemberDTO[]>;
	public abstract editServiceStateOnStaffMember(staffMemberId: number, serviceId: number, enabled: boolean): Promise<any>;
	public abstract postStaffMember(staffMember: IStaffMemberDTO): Promise<any>;
	public abstract patchStaffMember(patchDoc: any, staffMemberId: number): Promise<any>;
	public abstract deleteStaffMember(staffMemberId: number): Promise<any>;
	public abstract uploadStaffMemberPicture(file: any[], staffMemberId: number): Promise<any>;
	public abstract getStaffMembersAsAnonymous(adminId: string, request: IStaffMemberAnonymousRequestDTO): Promise<IStaffMemberBookingDTO[]>;
	public abstract getStaffMemberCount(adminId: string): Promise<number>;
	public abstract getStaffMemberStatistics(staffMemberId: number, year: number, month: number, day: number): Promise<IStaffMemberStatisticsDTO>;
	public abstract getStaffMemberCommissions(year: number, month: number): Promise<ICommissionDataDTO[]>;
}
